import React from 'react'
import Helmet from 'react-helmet'

import Layout from '../../components/layout'
import HeaderGeneric from '../../components/HeaderGeneric'

class Generic extends React.Component {

  render() {

    return (
      <Layout>
        <Helmet title="नामानुभव ग्रंथ" />
        <HeaderGeneric title="नामानुभव ग्रंथ" adhyaay=''/>
        <div id="main">
          <section id="content" className="main">
            <p>
सांगे गणामहाराज । भजा भजा नाम रोज ।< br />
नाही वाटणार बोज । तेणे मन शुद्ध रोज ॥ १ ॥< br />
< br />
माझे गुरू गजानन । सांगती मज निक्षुन ।< br />
नामात धुंद होऊन । जाशील भव तरून ॥ २ ॥< br />
< br />
गण गण गणात बोते । गुरू जाहले सांगते ।< br />
नित्य भज झाले वदते । नित्य अनित्य कळते ॥ ३ ॥< br />
< br />
अरे! तुझा गुरू कोण? । नामात पटेल खुण ।< br />
तळमळ नि ध्यासातुन । गुरुस आणशील ओढुन ॥ ४ ॥< br />
< br />
जे जे वदले गजानन । तंतोतंत खरे जाण ।< br />
नामाचे सप्ताह करवुन । भेट दिली घडवुन ॥ ५ ॥< br />
< br />
माझे गुरू पांडुरंग । तेणे जडला सत्संग ।< br />
नामात भेटती रोज । तैसे तुम्हां भेटो रोज ॥ ६ ॥< br />
< br />
गुरू पांडुरंग शास्त्री । लाभली कृपा छत्री ।< br />
नामात झाली खात्री । अष्टौप्रहर रात्री ॥ ७ ॥< br />
< br />
ज्याला लाभे साधुसंग । त्याला जडतो सत्संग ।< br />
तेणे शुद्ध अंतरंग । तुम्हा सांगे पांडुरंग ॥ ८ ॥< br />
< br />
नामात न मिळे काय ? । नामात तरते नांव ।< br />
नामात दूर दूर हाव । पांडुरंग करे सोय ॥ ९ ॥< br />
< br />
नित्य नाम आळवावे । काम काळ घालवावे ।< br />
पांडुरंगी लीन व्हावे । पांडुरंग शांती दावे ॥ १० ॥< br />
< br />
अंतरंग उकलावे । रुचेल ऐसे बोलावे ।< br />
कटुसत्य पटवावे । पांडुरंग मार्ग दावे ॥ ११ ॥< br />
< br />
कर्तव्य कर्म करावे । प्रपंची न लीप्त व्हावे ।< br />
अकर्ता भावे जगावे । पांडुरंग हीत दावे ॥ १२ ॥< br />
< br />
नामे पळते आसक्ती । नामे साधते विरक्ती ।< br />
नामे पळते अशांती । पांडुरंग दावे शांती ॥ १३ ॥< br />
< br />
माया चित्तास भुलवे । क्षणभंगुरी रमवे ।< br />
माया सर्वांस फसवे । पांडुरंगाचे ऐकावे ॥ १४ ॥< br />
< br />
नका गुरफटु मोहात । चित्तास जाळतो क्षणात ।< br />
पांडुरंग म्हणे नामात । अनुभवाल चित्त शांत ॥ १५ ॥< br />
< br />
येता जाता घेता नाम । भगवंताचा मुक्काम ।< br />
आपल्याच घरी ठाम । पांडुरंग शांती धाम ॥ १६ ॥< br />
< br />
जो सदा राहतो नामात । भगवंत त्याचे दारात ।< br />
नाम घेण्या मिळे निवांत । पांडुरंग बोल सत्य ॥ १७ ॥< br />
< br />
राहुन कर्तव्य कर्मात । जरी येई नाम मुखात ।< br />
सहज सोपे सर्वश्रेष्ठ । पांडुरंग म्हणे नामात ॥ १८ ॥< br />
< br />
नित्य स्मरा नारायण । तेणे लक्ष्मी प्रसन्न ।< br />
चिंता क्लेश पलायन । पांडुरंग समाधान ॥ १९ ॥< br />
< br />
योगेश्वरास भजता । शांती समाधान चित्ता ।< br />
करा योगेश्वर कर्ता । पांडुरंग म्हणे त्राता ॥ २० ॥< br />
< br />
योगेश्वर ऐसे नाम । तेणे साधे योगक्षेम ।< br />
पांडुरंग दावे नाम । तेणे शांती दया प्रेम ॥ २१ ॥< br />
< br />
ज्याच्या मुखी नाम सदा । तेणे टळते आपदा ।< br />
पांडुरंग म्हणे वदा । शिव शिव शंभो सदा ॥ २२ ॥< br />
< br />
भगवंतास स्मरावे । चिंता क्लेश विसरावे ।< br />
तेणे चित्ता तोषवावे । पांडुरंग मार्ग दावे ॥ २३ ॥< br />
< br />
भगवंताच्या नामात । आनंद येतो पुढ्यात ।< br />
पांडुरंग म्हणे त्यात । चिंता क्लेश टळतात ॥ २४ ॥< br />
< br />
चिंतेने मन उद्विग्न । नामाने मन प्रसन्न ।< br />
नामात जाल तरून । पांडुरंग शिकवण ॥ २५ ॥< br />
< br />
नको चिंता चिंतन । जेणे प्रसंग दारुण ।< br />
पांडुरंग सांगे निक्षुन । नामात जाल तरुन ॥ २६ ॥< br />
< br />
गुरूस सदा नमावे । त्याचेच बोल ऐकावे ।< br />
दुसर्‍यास विसरावे । पांडुरंग हीत दावे ॥ २७ ॥< br />
< br />
गुरू आज्ञा पालनात । नाम राहते मुखात ।< br />
तेणे भगवंत दारात । चिंता क्लेश टळतात ॥ २८ ॥< br />
< br />
ऐसे नाम आळवावे । भगवंताने ऐकावे ।< br />
हांक मारता धावावे । आपत्काळी रक्षावे ॥ २९ ॥< br />
< br />
नामानेच होते ज्ञान । पळून जाते अज्ञान ।< br />
तेणे होते आत्मज्ञान । पांडुरंग तत्वज्ञान ॥ ३० ॥< br />
< br />
सर्वव्यापी चराचरी । नामाने तोषतो भारी ।< br />
पांडुरंग म्हणे दारी । आला मागाया शिदोरी ॥ ३१ ॥< br />
< br />
नामात तुम्ही राहाता । आनंद अनुभवता ।< br />
आत्म्यास तृप्त करता । पांडुरंग नाम त्राता ॥ ३२ ॥< br />
< br />
माझा जन्म कशासाठी ? । नाम स्मरणासाठी ।< br />
तेणे भेटे जगत्‌जेठी । पांडुरंग सदा पाठी ॥ ३३ ॥< br />
< br />
भगवंतास भजता । तेणे भेटे जगत्‌त्राता ।< br />
चरणी ठेवता माथा । पांडुरंग ठरे त्राता ॥ ३४ ॥< br />
< br />
नाम स्मरा हो नाम । तेणे आनंद धाम ।< br />
भगवंत मुक्काम । पांडुरंग सोपे नाम ॥ ३५ ॥< br />
< br />
नाम येता मुखावरी । चिंता पळते सत्वरी ।< br />
श्रद्धा ठेवा एकावरी । तेच ठरे हितकारी ॥ ३६ ॥< br />
< br />
सदा “सदा” भजावे । भवदुःख हरावे ।< br />
आनंद अनुभवावे । तेच् हीत मानावे ॥ ३७ ॥< br />
< br />
जीव रमवा नामात । तेच् उपयुक्त प्रसंगात ।< br />
पांडुरंग म्हणे नामात । जडतो आनंद क्षणात ॥ ३८ ॥< br />
< br />
नामात होता तल्लीन । विसराल देहभान ।< br />
होता त्यात रममाण । पांडुरंग दर्शन ॥ ३९ ॥< br />
< br />
आळवावे नामाने । प्रसन्न व्हावे त्याने ।< br />
जगाल खात्रीने । शांती समाधानाने ॥ ४० ॥< br />
< br />
नामात होते तृप्ती । नामाने जडे शांती ।< br />
नको भलत्या पाठी । जगावे नामासाठी ॥ ४१ ॥< br />
< br />
भगवंत सर्व व्याप्त । खुण पटते नामात ।< br />
पांडुरंग म्हणे सत्य । अनुभवाल नामात ॥ ४२ ॥< br />
< br />
श्रद्धा ठेवा नामात । आनंद येईल पुढ्यात ।< br />
रहाल आनंदात । तरणोपाय नामात ॥ ४३ ॥< br />
< br />
भजा भजा पांडुरंग । तेणे शुद्ध अंतरंग ।< br />
तेणे जडे सत्संग । सांगे तुम्हा पांडुरंग ॥ ४४ ॥< br />
< br />
रामनाम जपावे । भवाब्धी तरावे ।< br />
रामनाम भजावे । सार्थक करावे ॥ ४५ ॥< br />
< br />
रामनाम भजण्यात । आनंद तत्क्षणात ।< br />
चिता क्लेश टळतात । प्रसन्नता चित्तात ॥ ४६ ॥< br />
< br />
नाम आळवा नाम । तेणे गुरू मुक्काम ।< br />
तेणे आनंद धाम । सच्चिदानंद धाम ॥ ४७ ॥< br />
< br />
नामाने सर्व प्राप्त । कळे आप्त इष्ट ।< br />
वेळ प्रसंगात । कोण उपयुक्त ॥ ४८ ॥< br />
< br />
नामात रमतो जीव । तेणे आनंदतो जीव ।< br />
नामात आनंद ठेव । पांडुरंग स्वानुभव ॥ ४९ ॥< br />
< br />
श्रद्धा ठेवा नामावर । तेणे तरले आजवर ।< br />
जो नामात राहाणार । आनंद अनुभवणार ॥ ५० ॥< br />
< br />
नित्य आळवा श्रीरंग । तेणे जडे सत्संग ।< br />
नित्य त्यात होता दंग । तेणे भेटतो श्रीरंग ॥ ५१ ॥< br />
< br />
नित्य श्रीरंग स्मरा । भव सागर तरा ।< br />
तेणे तोल सावरा । नामाचा मार्ग बरा ॥ ५२ ॥< br />
< br />
श्रीहरी भजा श्रीहरी । तेणे तरले आजवरी ।< br />
श्रीहरीच सोय करी । तोच जीवास उद्धरी ॥ ५३ ॥< br />
< br />
साधुसंतांचे ऐका । नामाने तरा नौका ।< br />
आत्म्याचा आवाज ऐका । बोजा होईल हलका ॥ ५४ ॥< br />
< br />
भगवंतास काय प्रिय ? । भगवंतास नाम प्रिय ।< br />
नामे होई भक्त प्रिय । नामानेच केली सोय ॥ ५५ ॥< br />
< br />
हरीस प्रिय भजन । प्रिय नामस्मरण ।< br />
करता गुणगान । हरी तोषे मनोमन ॥ ५६ ॥< br />
< br />
नामात होता तल्लीन । न शिवे विचार मलीन ।< br />
तेणे घडे सद्‌वर्तन । उपयुक्त नामस्मरण ॥ ५७ ॥< br />
< br />
नामाचे नाद घुमवा । नामात मन रमवा ।< br />
भगवंतास भुलवा । भगवंतास तोषवा ॥ ५८ ॥< br />
< br />
नामे टळे अहंकार । नामे भेटे निराकार ।< br />
नामाने होतो साकार । भक्तास रक्षणार ॥ ५९ ॥< br />
< br />
जे जे नामात रमले । भवसागर तरले ।< br />
सांगे तथ्य नामातले । पांडुरंग आठवले ॥ ६० ॥< br />
< br />
नाम येता मुखावरी । भेटे श्रीहरी सत्वरी ।< br />
चिंता क्लेश जाते दुरी । नाम जीवास उद्धरी ॥ ६१ ॥< br />
< br />
रमा रमा नामात । नित्य रहावे नामात ।< br />
नामाच्या सातत्यात । भगवंत दारात ॥ ६२ ॥< br />
< br />
नामाचे दास होण्यात । मायापाश तुटतात ।< br />
तेणे हरी भेटतात । चिंता क्लेश टळतात ॥ ६३ ॥< br />
< br />
सदा भजा शिवासी । तेणे सदा पाठीशी ।< br />
भजता सदा शिवासी । सदाशिव दाराशी ॥ ६४ ॥< br />
< br />
नाम रसाळ मधुर । नामाची फळे मधुर ।< br />
ती चाखण्या अधीर । येतो हरी सत्वर ॥ ६५ ॥< br />
< br />
कुणी कृष्ण म्हणा । कुणी राम म्हणा ।< br />
नाम मुखे म्हणा । तेच येते रक्षणा ॥ ६६ ॥< br />
< br />
रामकृष्ण हरी । भवसागर तारी ।< br />
त्याच्याच नामावरी । तरले आजवरी ॥ ६७ ॥< br />
< br />
रामनाम घ्यावे । नौकेत बसावे ।< br />
भवाब्धी तरावे । निश्चिंत असावे ॥ ६८ ॥< br />
< br />
नामात सुटे भवपाश । नामात भेटे जगदीश ।< br />
सकळ दुःख नाश । विनासायास ॥ ६९ ॥< br />
< br />
नका विसरू योगेश्वरा । तोच जीवनी साथी खरा ।< br />
सहाय्यभूत निराधारा । पांडुरंग बोल खरा ॥ ७० ॥< br />
< br />
योगेश्वरा आळवावे । चित्ता प्रसन्न करावे ।< br />
शांती समाधाने जगावे । पांडुरंग मार्ग दावे ॥ ७१ ॥< br />
< br />
योगेश्वर बंधु सखा । कुणा न करे पारखा ।< br />
थोर गरीब सारखा । पांडुरंगाचा सखा ॥ ७२ ॥< br />
< br />
नित्य स्मरा योगेश्वर । तेणे तरले आजवर ।< br />
शांती समाधान कोठार । पांडुरंगाचा आधार ॥ ७३ ॥< br />
< br />
भजा भजा योगेश्वरा । तेणे तरले आजवरा ।< br />
अशांतीस पार विसरा । पांडुरंग आचरा ॥ ७४ ॥< br />
< br />
नाम ज्याच्या मुखात । योगेश्वर दारात ।< br />
समाधान नामात । पांडुरंग दावतात ॥ ७५ ॥< br />
< br />
अहर्निष नामात । ध्यास लागे चित्तात ।< br />
पांडुरंग म्हणे त्यात । योगेश्वर प्रकटतात ॥ ७६ ॥< br />
< br />
येता जाता नाम वदता । तेणे आनंद अमृत साठा ।< br />
योगेश्वर ठरे कर्ता । पांडुरंग म्हणे त्राता ॥ ७७ ॥< br />
< br />
कैसे विसरू योगेश्वरास ? । हेच ठसवा चित्तास ।< br />
पांडुरंग म्हणे त्यास । सदा आनंद उल्हास ॥ ७८ ॥< br />
< br />
योगेश्वर नामात । वासना विरतात ।< br />
पांडुरंग म्हणे त्यात । प्रसन्नता चित्तात ॥ ७९ ॥< br />
< br />
योगेश्वर ऐसे नाम । कापे काळ काम ।< br />
समाधान मुक्काम । पांडुरंग म्हणे ठाम ॥ ८० ॥< br />
< br />
माझा योगेश्वर । सर्वांस आधार ।< br />
नामात पटणार । भरंवसा पांडुरंगावर ॥ ८१ ॥< br />
< br />
विसंबता नामावर । भेटे योगेश्वर ।< br />
तोच चित्ता तोषणार । पांडुरंग वदणार ॥ ८२ ॥< br />
< br />
पांडुरंग तरे नामावर । ठेवा भरंवसा त्यावर ।< br />
तेणे भेटे योगेश्वर । अनुभवे सांगणार ॥ ८३ ॥< br />
< br />
नामे जडे स्वाध्याय । अमृताची कोय ।< br />
आनंदाचा संचय । पांडुरंगे केली सोय ॥ ८४ ॥< br />
< br />
खरा स्वाध्यायी कोण ? । नाम पटवते खुण ।< br />
नाम करे शंका निरसन । पांडुरंग सांगे निक्षुन ॥ ८५ ॥< br />
< br />
नाम शिकवे स्वाध्याय । खरा खुरा गुरू होय ।< br />
जडे अमृताची ठेव । पांडुरंगे केली सोय ॥ ८६ ॥< br />
< br />
नित्य नाम भजण्यात । वृत्ती आनंदतात ।< br />
सत्कर्मे घडतात । पांडुरंग वदतात ॥ ८७ ॥< br />
< br />
नित्य नाम भजावे । नित्य अनित्य पहावे ।< br />
आत्म्यास तोषावे । पांडुरंग हीत दावे ॥ ८८ ॥< br />
< br />
नित्य नाम भजता । भेटतो जगत्‌त्राता ।< br />
शांती समाधान चित्ता । कर्मे करून अकर्ता ॥ ८९ ॥< br />
< br />
नित्य नाम वदावे । भगवंता आळवावे ।< br />
चिंता क्लेश टाळावे । गुरू बोल ऐकावे ॥ ९० ॥< br />
< br />
ऐसे नाम आळवा । भगवंत तोषावा ।< br />
चित्ता आनंद व्हावा । जीव सार्थक करावा ॥ ९१ ॥< br />
< br />
भजता नित्य नाम । कर्म योग निष्काम ।< br />
विरे त्यात सकाम । तेणे शांती धाम ॥ ९२ ॥< br />
< br />
नित्य नामाचा ध्यास । आनंद सहवास ।< br />
तेच हवे आत्म्यास । पांडुरंग सांगे खास ॥ ९३ ॥< br />
< br />
घेता नामाचा श्वास । आनंद सहवास ।< br />
आनंद शोधण्यास । जगदीश दारास ॥ ९४ ॥< br />
< br />
नित्य नाम भजता । जडे आनंद साठा ।< br />
तेणे अमृत वाटा । पांडुरंग त्राता ॥ ९५ ॥< br />
< br />
नामे हांक मारता । उभा राहे जगत्‌त्राता ।< br />
तोच ठरे रक्षणकर्ता । तेणे आनंद चित्ता ॥ ९६ ॥< br />
< br />
येता जाता घेता नाम । तेणे साधे निष्काम ।< br />
तेणे भगवंत मुक्काम । आनंद शांती धाम ॥ ९७ ॥< br />
< br />
विसरू नये नामास । हाच असावा ध्यास ।< br />
घेता नामाचा घास । होती चिंता क्लेश र्‍हास ॥ ९८ ॥< br />
< br />
नाम येता मुखावर । आपण येतो भानावर ।< br />
तेणे कुकर्मे टळणार । सुफळे मिळणार ॥ ९९ ॥< br />
< br />
नामाचे नाद घुमवा । दुसर्‍यांस ऐकवा ।< br />
आनंद कण वाटावा । भगवंत तोषावावा ॥ १०० ॥< br />
< br />
नित्य नाम वदा । नित्य नाम वदा ।< br />
तेणे आनंद सर्वदा । तोषे श्रीरंग सर्वदा ॥ १०१ ॥< br />
< br />
नित्य नाम भजा । नित्य नाम भजा ।< br />
भय चिंता न काळजा । तेणे दुःख वजा ॥ १०२ ॥< br />
< br />
नित्य नाम आळवा । आळस घालवावा ।< br />
यत्न आचरावा । भगवंत तोषवावा ॥ १०३ ॥< br />
< br />
नामावर प्रपंच सोपा । हाच मार्ग सोपा ।< br />
तेणे परमार्थ सोपा । गुरू सांगे मार्ग सोपा ॥ १०४ ॥< br />
< br />
राहाता नित्य नामात । नारायण प्रकटतात ।< br />
लक्ष्मी पाऊले उमटतात । पांडुरंग वदतात ॥ १०५ ॥< br />
< br />
नित्य नाम वदावे । नारायणा तोषवावे ।< br />
आत्म्यास तोषवावे । पांडुरंग मार्ग दावे ॥ १०६ ॥< br />
< br />
नित्य नाम भजण्यात । शंका कुशंका विरतात ।< br />
त्यांच्या निरसनात । आनंद चित्तात ॥ १०७ ॥< br />
< br />
नामात भरला अर्थ । तेणे प्रपंच परमार्थ ।< br />
खरा जीवनाचा अर्थ । तेणे स्वार्थ परमार्थ ॥ १०८ ॥< br />
< br />
नामाने आळवा नाम । पांडुरंग नाम ।< br />
सहज सोपे नाम । न करावे लागे मुद्दाम ॥ १०९ ॥< br />
< br />
नामात होता रममाण । विसरता देहभान ।< br />
तेणे खरे खुरे ज्ञान । पळुन जाते अज्ञान ॥ ११० ॥< br />
< br />
नामाच्या प्रकाशात । अज्ञान लुप्त होतात ।< br />
ज्ञान किरण तेजात । वृत्ती संतोषतात ॥ १११ ॥< br />
< br />
येता नाम मुखावर । हरी लुब्ध त्यावर ।< br />
तेणेच हरी भेटणार । चिंता क्लेश हरणार ॥ ११२ ॥< br />
< br />
नित्य नामात रहाता । सहज भावे जगता ।< br />
आनंद वृत्तीने जगता । कधी न कंटाळता ॥ ११३ ॥< br />
< br />
नित्य नाम वदा । हरी स्वये बोले सदा ।< br />
तेणे संतोषे सदा । भेटे आनंद देण्या सदा ॥ ११४ ॥< br />
< br />
नित्य भजा नाम । सदाशिव मुक्काम ।< br />
सोडून कैलासधाम । शोधे भक्तधाम ॥ ११५ ॥< br />
< br />
नाम भजता हरघडी । ऐसा भक्त आवडी ।< br />
भगवंत मार्ग काढी । भक्तां शोधुन काढी ॥ ११६ ॥< br />
< br />
नाम घेता भगवंताचे । तेणे भय न चिंतेचे ।< br />
मार्ग शांती समाधानाचे । ऐकावे पांडुरंगाचे ॥ ११७ ॥< br />
< br />
मुखे भजता गजानन । तेणे चिंता पलायन ।< br />
तेणे शांती समाधान । तेणे स्फुर्ती चैतन्य ॥ ११८ ॥< br />
< br />
गजानन नामात । संकटे घाबरतात ।< br />
मार्ग सुकर होतात । आनंद क्षण लाभतात ॥ ११९ ॥< br />
< br />
नामाच्या चिंतनात । चिंता पळतात ।< br />
समाधान चित्तात । आनंद पुढ्यात ॥ १२० ॥< br />
< br />
ऐसे नाम आळवावे । भगवंताने ऐकावे ।< br />
त्याचे चित्त भुलावे । भक्तघर शोधावे ॥ १२१ ॥< br />
< br />
नाम भजावे नाम । सहज सोपे नाम ।< br />
न मोजावे लागे दाम । कलीयुगी श्रेष्ठ नाम ॥ १२२ ॥< br />
< br />
नाम ज्याच्या मुखाला । कली घाबरे त्याला ।< br />
कली शरण नामाला । विसरू नका नामाला ॥ १२३ ॥< br />
< br />
चिंतेच्या चिंतनात । चिंता येते पुढ्यात ।< br />
भगवंताच्या नामात । भगवंत पुढ्यात ॥ १२४ ॥< br />
< br />
नामे टळतो अहंकार । तेणे निराकार साकार ।< br />
भवचिंता सरणार । आनंद मिळणार ॥ १२५ ॥< br />
< br />
राहाता नामात सदा । तेणे संतोषतो ‘सदा’ ।< br />
निवांत मिळतो सदा । पाठीराखा ठरे ‘सदा’ ॥ १२६ ॥< br />
< br />
नाम घ्यावे कुणाचे ? । ऐसे न विचारायचे ।< br />
महत्व आहे श्रद्धेचे । बोल अनुभवाचे ॥ १२७ ॥< br />
< br />
नामाचे होता दास । तेणे तुटे भवपाश ।< br />
भगवंत दारास । येतो विनासायास ॥ १२८ ॥< br />
< br />
दास होता नामाचे । न व्हाल दास कुणाचे ।< br />
भगवंतही दास नामाचे । ऐसे महत्व नामाचे ॥ १२९ ॥< br />
< br />
दास व्हावे नामाचे । ऐका बोल आत्म्याचे ।< br />
विरुद्ध ऐकण्याचे । हीत न व्हावयाचे ॥ १३० ॥< br />
< br />
राहाता तुम्ही नामात । आत्म्याच्या संपर्कात ।< br />
त्याचे बोल ऐकण्यात । सत्कर्मे घडतात ॥ १३१ ॥< br />
< br />
बोला नाम पुष्कळ । तेणे कळे सकळ ।< br />
नको निंदा वायफळ । नामच सांगे सकळ ॥ १३२ ॥< br />
< br />
घेता नाम अगणिक । सोपे होते गणित ।< br />
कोडी उकलतात । नाना प्रसंग टळतात ॥ १३३ ॥< br />
< br />
नामाशी नाते जडता । दूर होते जडता ।< br />
तेणे भगवंताचा पत्ता । सहज शोधुन काढता ॥ १३४ ॥< br />
< br />
नामात होता धुंद । तेणे दरवळे सुगंध ।< br />
शोधण्या नाम सुगंध । निघे भगवंत वृंद ॥ १३५ ॥< br />
< br />
दरवळता नाम सुगंध । तेणे भगवंत धुंद ।< br />
हुडकण्यात तो धुंद । देहभानाची न शुद्ध ॥ १३६ ॥< br />
< br />
नामाच्या जयघोषात । भगवंत प्रकटतात ।< br />
जयघोषे ते तोषतात । सदा भक्तां सांगतात ॥ १३७ ॥< br />
< br />
नामे तोषतो भगवंत । तेणे तोषतो भक्त ।< br />
नामाच्या सान्निद्ध्यात । सर्वच तोषतात ॥ १३८ ॥< br />
< br />
नामाच्या ठेवीवर । व्याज वाढे सत्वर ।< br />
खर्चिले तरी वाढणार । अगणित होणार ॥ १३९ ॥< br />
< br />
नुसत्या नामोच्चारात । सर्व विद्या प्रकटतात ।< br />
विविध प्रसंगात । उपयुक्त ठरतात ॥ १४० ॥< br />
< br />
नामच शिकवे योग । तेच शिकवे विनियोग ।< br />
तेणे प्रारब्धभोग । भोगता तुम्ही सहज ॥ १४१ ॥< br />
< br />
सहजगता नामात । सहजगत्या पुढ्यात ।< br />
नको अवडंबरात । नाम सांगे प्रत्यक्षात ॥ १४२ ॥< br />
< br />
नाम भजता अक्षय । तेणे आनंद अक्षय ।< br />
तेणेच होता निर्भय । वरदान अभय ॥ १४३ ॥< br />
< br />
नाम घेता अक्षय । कधी न होई क्षय ।< br />
न होणार कधी व्यय । ऐसे नाम अक्षय ॥ १४४ ॥< br />
< br />
अक्षय नामात । अक्षय पुढ्यात ।< br />
क्षय न कधी त्यात । नामाच्या अक्षयात ॥ १४५ ॥< br />
< br />
ऐसे नाम गजानन । जीव जातो उद्धरून ।< br />
करता नामस्मरण । शांती समाधान ॥ १४६ ॥< br />
< br />
नामे तोषे गजानन । मनोमनी प्रसन्न ।< br />
अभय वरदान । देती गजानन ॥ १४७ ॥< br />
< br />
मुखे म्हणा गजानन । करा कर्तव्य पालन ।< br />
प्रपंचात राहुन । निरासक्त हो‌ऊन ॥ १४८ ॥< br />
< br />
गजानन गजानन । ऐसे करता नामस्मरण ।< br />
चमत्कृतीमय जीवन । टाळाल प्रसंग दारूण ॥ १४९ ॥< br />
< br />
नामे करता प्रपंच । लाभे नाम कवच ।< br />
जरी अवघड प्रपंच । होई सहज सोपा प्रपंच ॥ १५० ॥< br />
< br />
नामे दूर पळे गर्व । नामे पळे अहंभाव ।< br />
नामे जागृत दयाभाव । सत्कृत्यास वाव ॥ १५१ ॥< br />
< br />
व्हावे नामात रममाण । हेच जीवनी शहाणपण । < br />
तेणे मन प्रसन्न । मन न कधी उद्विग्न ॥ १५२ ॥< br />
< br />
नामाने होता सावध । न कधी बेसावध ।< br />
नामाने तत्व बोध । नामाने आत्मबोध ॥ १५३ ॥< br />
< br />
सावध होतो नामात । राहे अनुसंधानात ।< br />
उपयुक्त रक्षणात । वेळ प्रसंगात ॥ १५४ ॥< br />
< br />
नामाची ऐशी किमया । नाम न जाई वाया ।< br />
नामाचा करता धावा । भगवंत उभा राहावा ॥ १५५ ॥< br />
< br />
नाम जीवनी उपयुक्त । सोपे साधन श्रेष्ठ ।< br />
तेणे भाव उत्कट । जागृत होतात ॥ १५६ ॥< br />
< br />
नामाची असता साथ । न राहे कुणी अनाथ ।< br />
भेटतो सत्वर नाथ । करण्या प्रसंगावर मात ॥ १५७ ॥< br />
< br />
नामाच्या संगतीत । वृत्ती आनंदतात ।< br />
जीव रमे शांतीत । तेणे राहे सदोदीत ॥ १५८ ॥< br />
< br />
नाम घ्यावे नाम घ्यावे । भगवंतास आळवावे ।< br />
ऐसे नाम पुकारावे । स्वये भगवंताने यावे ॥ १५९ ॥< br />
< br />
भगवंत भुलतो नामाला । न कंटाळे नामाला ।< br />
नामातच भेटेन तुला । सांगे भगवंत भक्ताला ॥ १६० ॥< br />
< br />
नामात रममाण व्हावे । चिंता क्लेश टाळावे ।< br />
सदा आनंदी राहावे । जीवन सार्थक करावे ॥ १६१ ॥< br />
< br />
नामाच्या सातत्यात । वृत्ती आनंदतात ।< br />
तेणेच सत्कर्मे घडतात । कुकर्मे टळतात ॥ १६२ ॥< br />
< br />
नाम महिमा अगाध । न कशाचा बाध ।< br />
आनंद निर्विवाद । नामातच होतो बोध ॥ १६३ ॥< br />
< br />
नामाने भाग्य उजळते । पदोपदी हे पटते ।< br />
प्रारब्ध सुसह्य होते । संत बोल खरे ठरते ॥ १६४ ॥< br />
< br />
संत तरले नामावर । भरंवसा ठेवे नामावर ।< br />
मात केली प्रसंगावर । म्हणे हाच नामाचा सार ॥ १६५ ॥< br />
< br />
नामात आपण रमावे । देहभान विसरावे ।< br />
सुखदुःखा महत्व न द्यावे । नामावरच जगावे ॥ १६६ ॥< br />
< br />
नामाच्या सान्निद्ध्यात । सुख दुःखे न उरतात ।< br />
न कधी जाणवतात । प्रारब्ध भोग सुसह्य होतात ॥ १६७ ॥< br />
< br />
नाम घ्यावे भगवंताचे । व्हावे आपण नामाचे ।< br />
नामाने अनेकांचे । सार्थक केले जीवनाचे ॥ १६८ ॥< br />
< br />
येता जाता नामस्मरण । तेणे भगवंत दर्शन ।< br />
तेणे शंका निरसन । संत सांगती निक्षुन ॥ १६९ ॥< br />
< br />
नाम स्मरावे केव्हाही । नाम स्मरावे कुठेही ।< br />
तेणे भगवंत कुठेही । दिसे भगवंत केव्हाही ॥ १७० ॥< br />
< br />
नामात मिळे आनंद । तेणे भेटे परमानंद ।< br />
तेणे सत् चित् आनंद । तेणे सच्चिदानंद ॥ १७१ ॥< br />
< br />
नाम घ्यावे भगवंताचे । होऊन रहावे त्याचे ।< br />
न भय चिंता काळजीचे । तेणे क्षण आनंदाचे ॥ १७२ ॥< br />
< br />
नित्य नामात आनंद । तेणे आत्म्यास आनंद ।< br />
चराचरतला आनंद । करतो मना धुंद ॥ १७३ ॥< br />
< br />
नाम स्मरा, नाम स्मरा । भवदुःख हरा, चिंता हरा ।< br />
आनंद खरा, स्वये घरा । मिळे खरा, नामात सारा ॥ १७४ ॥< br />
< br />
नामात कळे पाप पुण्य । इतुके सोपे साधन ।< br />
भरंवसा त्यावर ठेवुन । कित्येक गेले तरून ॥ १७५ ॥< br />
< br />
नामाचे होता दास । तेणे राम दारास ।< br />
रामाचे होता दास । तेणे रामदास ॥ १७६ ॥< br />
< br />
दास होता नामाचे । दास होता रामाचे ।< br />
राम दास त्याचे । राम नाम जपणार्‍याचे ॥ १७७ ॥< br />
< br />
मुखे म्हणा रामनाम । अहर्निष रामनाम ।< br />
तेणे साधे निष्काम । जेणे तोषे श्रीराम ॥ १७८ ॥< br />
< br />
रामनाम भजावे । श्रद्धेने ते भजावे ।< br />
तेणे चित्ता तोषावावे । जीवन सार्थक करावे ॥ १७९ ॥< br />
< br />
रामनाम घ्यावे । कर्तव्य पालन करावे ।< br />
अकर्ता भावे जगावे । अहंभाव विसरावे ॥ १८० ॥< br />
< br />
मुखी असता रामनाम । विषयास लगाम ।< br />
घाबरे काळकाम । तेणे भक्तीचे धाम ॥ १८१ ॥< br />
< br />
रामनाम भजा । रामनाम भजा ।< br />
नष्ट होई भाव दुजा । लहान, थोर, खुजा ॥ १८२ ॥< br />
< br />
रामनाम आळवता । चिंता काळजी घालवता ।< br />
तेणे प्रसन्न करता चित्ता । जीवन सार्थक करता ॥ १८३ ॥< br />
< br />
रामनाम भजण्यात । शीळा उद्धरे त्यात ।< br />
रामनामे सुसह्य होतात । जरी भोग भोगतात ॥ १८४ ॥< br />
< br />
रामनाम भजावे । रामनामी तल्लीन व्हावे ।< br />
सभोवताल विसरावे । जरी त्यात रहावे ॥ १८५ ॥< br />
< br />
भजा भजा रामनाम । तेणे श्रीराम मुक्काम ।< br />
चिंता काळजीस रामराम । तेणे समाधान मुक्काम ॥ १८६ ॥< br />
< br />
रामाचे होता दास । चिंता काळजी र्‍हास ।< br />
नामाचा एकेक श्वास । तेणे भगवंताचा वास ॥ १८७ ॥< br />
< br />
राम दास कुणाचा ? । राम दास नामाचा ।< br />
राम दास त्याचा । जो सदा रामाचा ॥ १८८ ॥< br />
< br />
नामाचे दास होण्यात । रामच दास होतात ।< br />
सारा प्रपंच करतात । भवताप ते हरतात ॥ १८९ ॥< br />
< br />
नामाचे दास व्हावे । आत्म्याचे बोल ऐकावे ।< br />
वृत्तीचे तोल सावरावे । तेणे समतोल साधावे ॥ १९० ॥< br />
< br />
पळें पळें नामात । पळें पळें तोषतात ।< br />
चिंता पळे त्यात । रहाता आनंदात ॥ १९१ ॥< br />
< br />
पळें पळें नाम भजता । पळें पळें आनंद चित्ता ।< br />
चिंता काळजी घालवता । सहजभावे जगता ॥ १९२ ॥< br />
< br />
नामाचा एकेक पळ । वाढवे मनोबळ ।< br />
चिंता काळजी सकळ । त्वरित काढे पळ ॥ १९३ ॥< br />
< br />
नामाच एकेक क्षण । करे मन प्रसन्न ।< br />
तेणे चित्ता समाधान । शांतीस सदा स्थान ॥ १९४ ॥< br />
< br />
नामाचा सहवास । तेणे पापाचा र्‍हास ।< br />
पुण्य येते उदयास । नाम उद्धरे जीवास ॥ १९५ ॥< br />
< br />
नुसत्या नामोच्चारात । उच्चार प्रभावी होतात ।< br />
प्रभावी उच्चारात । सर्व थक्क होतात ॥ १९६ ॥< br />
< br />
नामाची ऐशी शिकवण । तेणे सदाचरण ।< br />
तेणे सत्शील वर्तन । तेणे सुसंगत जीवन ॥ १९७ ॥< br />
< br />
नामाची असता सोबत । तेणे सत्‌संग सोबत ।< br />
कठिण प्रसंगात । भगवंत सोबत ॥ १९८ ॥< br />
< br />
नामजप करावे । श्रेष्ठ तप मानावे ।< br />
भगवंताचे ऐकावे । भगवंता तोषवावे ॥ १९९ ॥< br />
< br />
नामाचे दास होण्यात । लौकीक विसरतात ।< br />
कर्तव्यकर्मे करतात । भगवंताचे होतात ॥ २०० ॥< br />
< br />
नाम सहवासात । लौकीक दारात ।< br />
पाहुणा मानतात । पळभराचा म्हणतात ॥ २०१ ॥< br />
< br />
नामाने जे जे कळते । ते ते मनास पटते ।< br />
तेणे मनासारखे होते । चित्ता शांती लाभते ॥ २०२ ॥< br />
< br />
नामे होतो साकार । जरी निराकार ।< br />
नामेच तोषणार । सदा भक्ता भेटणार ॥ २०३ ॥< br />
< br />
नाम घ्या नाम घ्या । तेणे प्रारब्ध भोगा ।< br />
शांती समाधाने जगा । तेणे न भय काळजा ॥ २०४ ॥< br />
< br />
नाम घ्या हो, नाम घ्या हो । तेणे भवाब्धी तरा हो ।< br />
तेणे पैलतीर गाठा हो । जीवन सार्थक करा हो ॥ २०५ ॥< br />
< br />
नामात गुंतवावे चित्त । तेणे लाभे मनःस्वास्थ्य ।< br />
नामातले खरे तथ्य । कळे नामात राहण्यात ॥ २०६ ॥< br />
< br />
नामात राहता तुम्ही । विसरता तुम्ही आम्ही ।< br />
काही न करत ‘मी’ । नामात जाणता तुम्ही ॥ २०७ ॥< br />
< br />
नाम जोडते संबंध । तेणे मिळतो आनंद ।< br />
त्यातच होता धुंद । जमवता संत वृंद ॥ २०८ ॥< br />
< br />
नामस्मरण करण्याते । मोहमाया कळते ।< br />
मोहमाया न जाळते । नामच उपयुक्त ठरते ॥ २०९ ॥< br />
< br />
वृथा नको वटवट । नामाची करा खटपट ।< br />
त्यातच विसराल देहकष्ट । संत बोल ठरे सत्य ॥ २१० ॥< br />
< br />
नाम येता मुखात । वटवट थांबे क्षणात ।< br />
वटवट न उपयुक्त । हेच पटते नामात ॥ २११ ॥< br />
< br />
नको वायफळ बडबड । तेणे होते गडबड ।< br />
नामाची करता धडपड । काही न वाटे अवघड ॥ २१२ ॥< br />
< br />
नामाचे बोला बोल । तेणे सावरेल तोल ।< br />
तेणे जीवन समतोल । पटते मनावर खोल ॥ २१३ ॥< br />
< br />
नामाचा एकेक क्षण । धुंद करतो विलक्षण ।< br />
आनंदाचा एकेक कण । येतो आपणहुन ॥ २१४ ॥< br />
< br />
नाम मधुर गोड । त्याचा सहवास गोड ।< br />
नामाची मिळता जोड । तेणे भगवंताची जोड ॥ २१५ ॥< br />
< br />
नामे जोडता एकेक । तेणे जडे भाव ऐक्य ।< br />
नामाने शत्रु एकेक । करे सोयरीक ॥ २१६ ॥< br />
< br />
नामात कळते कित्येक । नामात मिळते कित्येक ।< br />
नामात विरे सुखदुःख । तेणे आनंद शिल्लक ॥ २१७ ॥< br />
< br />
नामाचे न मोजमाप । तेच कळे आपोआप ।< br />
अमाप नामाचे अमाप । तेणे सरती भवताप ॥ २१८ ॥< br />
< br />
नामात तुम्ही असता । भवतापास विसरता ।< br />
आनंदास मिळवता । शांती समाधान चित्ता ॥ २१९ ॥< br />
< br />
जितुके तुम्ही नामात । तितुका आनंद पुढ्यात ।< br />
जितुके प्रपंचात । तितुके भवतापात ॥ २२० ॥< br />
< br />
भवाचा ताप होता । नामास आळवता ।< br />
परी आधी नाम आळवता । न भवताप चित्ता ॥ २२१ ॥< br />
< br />
प्रपंचातली ओढ । हव्यासास ओढ ।< br />
नामस्मरणातली ओढ । भगवंताची जोड ॥ २२२ ॥< br />
< br />
प्रपंचातली जाणीव । तीच दावते उणीव ।< br />
नामात रमवावा जीव । नामालाच आपली कीव ॥ २२३ ॥< br />
< br />
आधी विचार नामाचा । मग करा प्रपंचाचा ।< br />
नामानेच जगण्याचा ।  निश्चय करा मनाचा ॥ २२४ ॥< br />
< br />
नामाची करता सोय । नामच करते सोय ।< br />
नामात रमवता जीव । नामच रमवते जीव ॥ २२५ ॥< br />
< br />
नामाचा एकेक पळ । तेणे बोध सकळ ।< br />
नामात मिळे सुफळ । न कधी विफळ ॥ २२६ ॥< br />
< br />
नामानेच जगण्यात । आनंदे जगण्यात ।< br />
नामाने आनंदात । आनंदे नामात ॥ २२७ ॥< br />
< br />
नामात रमा । नामात रमा ।< br />
उपयुक्त कामा । पोहोचण्या मुक्कामा ॥ २२८ ॥< br />
< br />
रमा रमा नामात । तेणे आनंद पुढ्यात ।< br />
रमा रमा आनंदात । तेणेच नाम मुखात ॥ २२९ ॥< br />
< br />
नामात तल्लीन असता । तेणे भय न चित्ता ।< br />
आनंद वृत्तीचा साठा । चित्त शांत असता ॥ २३० ॥< br />
< br />
नामात भेटे पांडुरंग । तेणे जीवन सुसंग ।< br />
तेणे टळे कुसंग । जडे सदा सत्संग ॥ २३१ ॥< br />
< br />
नामातला एकेक क्षण । देतो आनंद विलक्षण ।< br />
चिंता क्लेश पलायन । होता नामात रममाण ॥ २३२ ॥< br />
< br />
सुखाच्या हव्यासात । चिंता क्लेश पुढ्यात ।< br />
नामाच्या हव्यासात । समाधान पुढ्यात ॥ २३३ ॥< br />
< br />
नामाच्या सान्निध्यात । सत्कर्मे घडतात ।< br />
अहंभाव लुप्त होतात । कर्तव्य भावे जगतात ॥ २३४ ॥< br />
< br />
भगवंताच्या नामात । वृत्ती आनंदतात ।< br />
चिंता क्लेश टळतात । समाधाने जगतात ॥ २३५ ॥< br />
< br />
करता नामाचे स्मरण । भगवंतास आमंत्रण ।< br />
नामावर गेले तरून । भगवंत सांगे निक्षुन ॥ २३६ ॥< br />
< br />
नामाची नको शंका । नामच करते दूर शंका ।< br />
नामात भेटे पाठीराखा । तोच उपयुक्त खरा सखा ॥ २३७ ॥< br />
< br />
नामावाचुन जगणे । जेणे जीवंत मरणे ।< br />
नामानेच जगणे । मरणोत्तर जगणे ॥ २३८ ॥< br />
< br />
नामात जीव रमवा । अंतरात्म्यास तोषवा ।< br />
आनंद आपला व्हावा । जीव त्यात रमवा ॥ २३९ ॥< br />
< br />
नामात जीव रमता । तेणे येते प्रसन्नता ।< br />
सभोवताली असता । स्थिर चित्ते वागता ॥ २४० ॥< br />
< br />
नामातच सर्व मिळते । हे नामानेच कळते ।< br />
नामानेच तृप्ती होते । अतृप्त न रहाते ॥ २४१ ॥< br />
< br />
नामात सदा डुंबावे । मलीन घालवावे ।< br />
ताजे तवाने रहावे । प्रसन्नतेने जगावे ॥ २४२ ॥< br />
< br />
नामात डुंबत रहाता । एकचित्त साधता ।< br />
तेणे येते एकसूत्रता । तेणे सुसंगतता ॥ २४३ ॥< br />
< br />
डुंबुन रहावे नामात । आनंद मिळे नामात ।< br />
थकवा उतरे क्षणात । विरंगुळा लाभे त्यात ॥ २४४ ॥< br />
< br />
डुंबुन रहा हो नामात । हेच सांगती साधुसंत ।< br />
राहुन प्रपंचात । रहाल आनंदात ॥ २४५ ॥< br />
< br />
नामावर तरले सारे । अज्ञानी बापडे बिचारे ।< br />
नामात जे जे रमणारे । ते ते ज्ञानी झाले सारे ॥ २४६ ॥< br />
< br />
नामात होते ज्ञान । पळुन जाते अज्ञान ।< br />
नामात होता रममाण । ज्ञानाची सापडे खाण ॥ २४७ ॥< br />
< br />
नाम घ्यावे एकांतात । तेणे भय न चित्तात ।< br />
मलीनता न मनात । प्रसन्नता चित्तात ॥ २४८ ॥< br />
< br />
नामात गुंतविता चित्त । न गुंते ते विषयात ।< br />
नामच उपयुक्त । ठरे सर्व प्रसंगात ॥ २४९ ॥< br />
< br />
नामाने जे जे मिळते । विषयात न मिळते ।< br />
विषयात सर्व जाते । नामात सर्व मिळते ॥ २५० ॥< br />
< br />
नामात गुंतवा चित्ता । चिंता उद्भवता ।< br />
नामात तल्लीन होता । चिंतेस विसरता ॥ २५१ ॥< br />
< br />
चित्त गुंतवा नामात । चिंता पळते क्षणात ।< br />
फक्त रहाता नामात । तेणे रहाता आनंदात ॥ २५२ ॥< br />
< br />
चिंता जाळते चित्तास । हेच येते अनुभवास ।< br />
परी राहाता नामास । अनुभवाल आनंदास ॥ २५३ ॥< br />
< br />
नामातले स्वेदबिंदु । तारतात भवसिंधु ।< br />
सगे सोयरे बंधु । म्हणे नामास वंदु ॥ २५४ ॥< br />
< br />
नामास आळवावे । नामाचेच ऐकावे ।< br />
साधे भाबडे रहावे । तेणे पैलतीरी जावे ॥ २५५ ॥< br />
< br />
रमा रमा नामात । तल्लीन व्हा नामात ।< br />
नामाचे नाद ऐकण्यात । रहाल आनंदात ॥ २५६ ॥< br />
< br />
नामात जीव रमवा । अनुसंधान टिकवा ।< br />
तेणे आनंद मिळवा । तेणे आनंद टिकवा ॥ २५७ ॥< br />
< br />
नामाच्या अनुसंधानात । सत्कर्मे घडतात ।< br />
सत्कर्मे आचरणात । शुभाशिष मिळतात ॥ २५८ ॥< br />
< br />
नामात तुम्ही राहाता । आत्म्याचे बोल ऐकता ।< br />
तैसे तुम्ही आचरता । आत्म्यास संतोषता ॥ २५९ ॥< br />
< br />
नामात तुम्ही रहावे । आत्म्याचेच ऐकावे ।< br />
मनाचे न ऐकावे । आत्म्यास तोषवावे ॥ २६० ॥< br />
< br />
रमा रमा नामात । रहा भोळ्या भावात ।< br />
तैसे आचरणात । परमेश्वराचे होतात ॥ २६१ ॥< br />
< br />
नामाचे होण्यात । मनोविकार टळतात ।< br />
सद्‌विचार प्रकटतात । सत्कर्मे घडतात ॥ २६२ ॥< br />
< br />
नामाचे व्हावे दास । तेणे विकाराचा र्‍हास ।< br />
थारा सुविचारास । सत्कर्मे आचरणास ॥ २६३ ॥< br />
< br />
नामावर विसंबावे । आधार मानावे ।< br />
नामानेच जगावे । जीवन सार्थक करावे ॥ २६४ ॥< br />
< br />
भगवंताच्या नामात । त्याच्या जयघोषात ।< br />
सुखदुःखे विरतात । आनंद क्षण लाभतात ॥ २६५ ॥< br />
< br />
नामाचे आपण व्हावे । नामात आपण रमावे ।< br />
नामावरच सोपवावे । आनंदात रहावे ॥ २६६ ॥< br />
< br />
आपण कुणाचे व्हावे ? । नामाचेच व्हावे ।< br />
प्रपंचात रमावे । परी नामास न विसरावे ॥ २६७ ॥< br />
< br />
नामास विसरण्यात । अहंभावे जगतात ।< br />
अहंकार होण्यात । विकार बळावतात ॥ २६८ ॥< br />
< br />
नाम म्हणजे काय ? । भगवंताची सोय ।< br />
परमार्थाची सोय । तेणे उद्धरतो जीव ॥ २६९ ॥< br />
< br />
नामास गुरू मानावे । गुरू बोल ऐकावे ।< br />
तैसेच आचरावे । आत्म्यास तोषावे ॥ २७० ॥< br />
< br />
नामाच्या जयघोषात । आत्मास तोषतात ।< br />
मनःशांतीने जगतात । आनंदे रहातात ॥ २७१ ॥< br />
< br />
नामाने मुख्य मिळते । मनःशांती मिळते ।< br />
तीच आधार ठरते । मन प्रसन्न रहाते ॥ २७२ ॥< br />
< br />
नामाने आळवावे । तेणे एकाग्र व्हावे ।< br />
जे जे बोल ऐकावे । ते चित्ता ठसवावे ॥ २७३ ॥< br />
< br />
फक्त ऐकता नामाचे । तेणे होता सर्वांचे ।< br />
तेणे क्षण भाग्याचे । होतात अनेकांचे ॥ २७४ ॥< br />
< br />
काय आहे माझे ? । फक्त माझे ओझे ।< br />
नाम म्हणण्यात माझे । हलके होते बोजे ॥ २७५ ॥< br />
< br />
जितुके नाम आळवाल । ‘मी’ स तितुका घालवाल ।< br />
‘मी’ स पार विसराल । त्यालाच आपला कराल ॥ २७६ ॥< br />
< br />
नामाने अनेकांची । सोय केली परमार्थाची ।< br />
खोडी जिरली स्वार्थाची । गोडी लागली परमार्थाची ॥ २७७ ॥< br />
< br />
नामाने सर्व जोडता । मोहपाश तोडता ।< br />
मोहास मागे टाकता । पाऊल पुढे टाकता ॥ २७८ ॥< br />
< br />
नामाच्या बंधनात । बंधने तुटतात ।< br />
पुढिल मुक्कामी जाण्यात । दुःखी न होतात ॥ २७९ ॥< br />
< br />
नामास आधार मानता । सर्व प्राप्त करता ।< br />
नामच मागे ठेवता । जरी पुढे जाता ॥ २८० ॥< br />
< br />
नामाचेच होण्यात । माझे माझे विसरतात । < br />
तुझे तुझे म्हणण्यात । सर्व प्राप्त करतात ॥ २८१ ॥< br />
< br />
माझे माझे म्हणण्यात । बोजे वाढवतात ।< br />
नामाने जगण्यात । हलके करतात ॥ २८२ ॥< br />
< br />
नामाने जे मिळते । ती ‘मी’ ने न मिळते ।< br />
हेही नामातच कळते । नामाचे महत्व पटते ॥ २८३ ॥< br />
< br />
नामाचे महत्व कळता । ‘मी’ स विसरता ।< br />
तेणे नामास आळवता । नामानेच जगता ॥ २८४ ॥< br />
< br />
नामाने ‘मी’ जातो । ‘तो’ सहज पुढे येतो ।< br />
तोच आधार ठरतो । तोच उपयुक्त ठरतो ॥ २८५ ॥< br />
< br />
नामजप करण्यात । भवसागर तरतात ।< br />
संत तरले नामात । आपणही तरावे त्यात ॥ २८६ ॥< br />
< br />
वाल्याने ‘राम’ भजला । तेणे वाल्या तरला ।< br />
लुटारू तपस्वी झाला । नामानेच उद्धरला ॥ २८७ ॥< br />
< br />
नाम असता मुखावरी । वृत्ती होते परोपकारी ।< br />
आशीष वरचेवरी । जे उपयुक्त संसारी ॥ २८८ ॥< br />
< br />
जे जे नामात रमले । नरदेहाचे सोने झाले ।< br />
जे जे विषयात रमले । चिंता क्लेशात घेरले ॥ २८९ ॥< br />
< br />
नामासक्त होण्यात । तरता भवसागरात ।< br />
कामासक्त होण्यात । डुबता भवसागरात ॥ २९० ॥< br />
< br />
नामासक्त असावे । कामासक्त नसावे ।< br />
जीवास उद्धरावे । जीवन सार्थक करावे ॥ २९१ ॥< br />
< br />
नामाने प्रेरणा मिळतात । त्याच आधार ठरतात ।< br />
त्या येता आचरणात । आनंदक्षण लाभतात ॥ २९२ ॥< br />
< br />
ऐसा नामजप करावा । भगवंत प्रसन्न व्हावा ।< br />
ऐसा करा त्याचा धांवा । स्वयेच जवळ यावा ॥ २९३ ॥< br />
< br />
नाम श्रद्धेने भजावे । नाम नीष्ठेने भजावे ।< br />
नामानेच त्याचे व्हावे । त्याचेवरच सोपवावे ॥ २९४ ॥< br />
< br />
प्रपंचाचा ताप भारी । हा जीव बेजार भारी ।< br />
परी असता नामावरी । मात करता प्रसंगावरी ॥ २९५ ॥< br />
< br />
विचार करावा नामाचा । नको नुसत्या प्रपंचाचा ।< br />
नामाने प्रसंग तरण्याचा । चिंतेने प्रसंग पोळण्याचा ॥ २९६ ॥< br />
< br />
नाम आळवा हो नाम । भगवंताचे सोपे नाम ।< br />
कुठचेही अवघड काम । सहज होते सोपे काम ॥ २९७ ॥< br />
< br />
श्रद्धेने नामजप करता । स्वानुभवे जगता ।< br />
खात्रीने पाऊल टाकता । आत्म्याचे आवाज ऐकता ॥ २९८ ॥< br />
< br />
कुठचेही क्षण असु द्या । नामात जीव रमु द्या ।< br />
नका म्हणु उद्या उद्या । सवड न मिळे उद्या ॥ २९९ ॥< br />
< br />
नाम जपावे आजच । निश्चय करावा हाच ।< br />
उपयुक्त तुम्हा नामच । आत्म्यासही हवे नाम ॥ ३०० ॥< br />
< br />
नामाचे अनुसंधान । तेणे जोडता संधान ।< br />
नामात जाल तरून । स्वानुभव पहावा घेऊन ॥ ३०१ ॥< br />
< br />
नामात काढता एकेक पळ । तेणे ज्ञान सकळ ।< br />
अज्ञान स्वये काढे पळ । दिसता ज्ञानाची मशाल ॥ ३०२ ॥< br />
< br />
हाती घेता ज्ञान मशाल । तेणे सत्‌पथ पहाल ।< br />
नामाने करता वाटचाल । मुक्कामी तुम्ही पोचाल ॥ ३०३ ॥< br />
< br />
नामात वेळ घालवता । चिंता क्लेश घालवता ।< br />
क्षणात आनंद मिळवता । चिरकाल तो टिकवता ॥ ३०४ ॥< br />
< br />
नामाचा महिमा अगाध । त्याचा न कुणा बाध ।< br />
नामात मिळवता अगाध । नामाने नाम अगाध ॥ ३०५ ॥< br />
< br />
आम्ही होणार नामाचे । फुकट न खाणार कुणाचे ।< br />
बोजे न होणार कष्टाचे । चीज होईल कष्टाचे ॥ ३०६ ॥< br />
< br />
नामाचे आपण होण्यात । नामाशी नाते जोडण्यात ।< br />
‘मी’ पळतो तत्क्षणात । जीव रमतो नामात ॥ ३०७ ॥< br />
< br />
नामाचे कार्य रमविण्याचे । दुसर्‍या आनंद देण्याचे ।< br />
मनःशांतीने जगविण्याचे । कार्य आहे नामाचे ॥ ३०८ ॥< br />
< br />
नामाने भगवत् प्राप्ती । हीच नामाची ख्याती ।< br />
नामाशी होता नाती गोती । अनेक कुळे उद्धरती ॥ ३०९ ॥< br />
< br />
नामाचा हुकुमी एक्का । विजय होतो पक्का ।< br />
नामाचा लागता शिक्का । कार्यभाग होतो पक्का ॥ ३१० ॥< br />
< br />
नामाची साथ असता । कार्यभाग साधता ।< br />
तेणे प्रसन्नता चित्ता । आनंदाने जगता ॥ ३११ ॥< br />
< br />
साथ असावी नामाची । सोबत असावी त्याची ।< br />
तेणे चिंता न भयाची । वाटचाल सुखशांतीची ॥ ३१२ ॥< br />
< br />
नामाची गुरूकिल्ली लाभता । अनेक कुलुपे उघडता ।< br />
भगवंताच्या जवळ जाता । त्याचेच होऊन राहाता ॥ ३१३ ॥< br />
< br />
नामात दिसतो भगवंत । जो आहे सर्व व्याप्त ।< br />
दिसतो विविध रुपात । खुण पटवतो क्षणात ॥ ३१४ ॥< br />
< br />
नामात होता एकरूप । दिसे अरूप स्वरूप ।< br />
तेच खरे स्वरूप । आनंदाचे स्वरूप ॥ ३१५ ॥< br />
< br />
नाते जोडावे नामाशी । ते न ठेवणार उपाशी ।< br />
नामाचा संबंध आत्म्याशी । नच नुसता पोटाशी ॥ ३१६ ॥< br />
< br />
नामाच्या संपर्कात । आत्म्यास तोषतात ।< br />
परमेश्वर चराचरात । सर्वांभूती दिसतात ॥ ३१७ ॥< br />
< br />
जे जे मिळते नामात । ते न मिळे कशात ।< br />
मुख्य मिळते नामात । सहज मिळते परसात ॥ ३१८ ॥< br />
< br />
नामाचा संबंध ईशाशी । कळते रहाता नामाशी ।< br />
‘तो’ स्वयेच येतो दाराशी । शिदोरी मागण्यासी ॥ ३१९ ॥< br />
< br />
नामाची शिदोरी ऐसी । भगवंतही भुले त्यासी ।< br />
गोडी लागली त्यासी । वरचेवर मागे भक्तासी ॥ ३२० ॥< br />
< br />
नामाच्या शिदोरीत । अनेक तृप्त होतात ।< br />
भगवंतही लुब्ध होतात । पुन्हां पुन्हां मागतात ॥ ३२१ ॥< br />
< br />
शिदोरी जाडी भरडी । परी नामामुळे गोडी ।< br />
भगवंतही न सोडी । ती चाखण्या शोधुन काढी ॥ ३२२ ॥< br />
< br />
शिदोरी असता नामाची । वेळ न उपासमारीची ।< br />
ढेकर येते तृप्तीची । ती खुण समाधानाची ॥ ३२३ ॥< br />
< br />
नामाच्या शिदोरीवर । सर्व तरले आजवर ।< br />
कुणीही तरणार । नामाच्या शिदोरीवर ॥ ३२४ ॥< br />
< br />
भगवंत भुले नामावर । नाम त्यास प्रिय फार ।< br />
हांक मारता धावणार । नामानेच पटणार ॥ ३२५ ॥< br />
< br />
नामाची शिदोरी करावी । त्याची वाट पहावी ।< br />
शिदोरी उष्टी करावी । हीच ईच्छा असावी ॥ ३२६ ॥< br />
< br />
नामाच्या शिदोरीला । भगवंतही भुलला ।< br />
शिदोरी खावयाला । भक्ताच्या घरी आला ॥ ३२७ ॥< br />
< br />
नामाची शिदोरी सर्वांची । कधी न एकट्याची ।< br />
सोय होते अनेकांची । खुण पटते नामाची ॥ ३२८ ॥< br />
< br />
नामस्मरण करावे । त्यातच तल्लीन व्हावे ।< br />
नामानेच तृप्त व्हावे । नामानेच अनुभव घ्यावे ॥ ३२९ ॥< br />
< br />
नामाचा ऐसा अनुभव । तेणेच तरता भव ।< br />
नामाने होता निर्भय । हाच नाम अनुभव ॥ ३३० ॥< br />
< br />
नामात होता रममाण । विसरता भूक तहान ।< br />
वेळेचेही न भान । होता नामात रममाण ॥ ३३१ ॥< br />
< br />
भगवंतास काय हवे ? । त्यास नामच हवे ।< br />
नामच मागतो स्वये । खुण पटवतो स्वये ॥ ३३२ ॥< br />
< br />
नामाची शिदोरी बाळगा । तेणेच भरा खळगा ।< br />
शिदोरीवरच जगा । शिदोरीचा अनुभव घ्या ॥ ३३३ ॥< br />
< br />
नामाच्या शिदोरीचे गाठोडे । अहो आहे मोठे केवढे ! ।< br />
सर्वांना वाढता वाढे । ऐसे नामाचे गाठोडे ॥ ३३४ ॥< br />
< br />
नाम शिदोरी गंमतीदार । वाढता ती वाढणार ।< br />
न वाढता, कमी होणार । ऐसे कुठे नसणार ॥ ३३५ ॥< br />
< br />
शिदोरी करा नामाची । सोय करा अनेकांची ।< br />
अनुभुती तृप्ततेची । अनुभुती आशीषांची ॥ ३३६ ॥< br />
< br />
नामाची शिदोरी असता । चिंता मुक्त असता ।< br />
समाधानाने जगता । तृप्ततेने जगता ॥ ३३७ ॥< br />
< br />
एक शिदोरी नामाची । भगवंताच्या आवडीची ।< br />
हाव सुटली शिदोरीची । तृप्ती होते भगवंताची ॥ ३३८ ॥< br />
< br />
सोपी शिदोरी नामाची । विना खटाटोपीची ।< br />
जेणे प्रिय अनेकांची । खुद्द भगवंताची ॥ ३३९ ॥< br />
< br />
जयघोष करा नामाचा । जयघोष करा रामाचा ।< br />
नको विचार ‘मी’चा । सदा विचार रामाचा ॥ ३४० ॥< br />
< br />
श्रीरामाच्या नामात । तरता तुम्ही प्रसंगात ।< br />
बनता धिरोदात्त । कधी न भयभीत ॥ ३४१ ॥< br />
< br />
बोल बोला रामाचा । जयजयकार करा त्याचा ।< br />
जेणे क्षण भाग्याचा । होईल भजणार्‍याचा ॥ ३४२ ॥< br />
< br />
पुरुषोत्तमाचा अवतार । सत्याचाच जयजयकार ।< br />
असत्य न टिकणार । रामनामे लोपणार ॥ ३४३ ॥< br />
< br />
श्रीराम श्रीराम म्हणा । तेणे सद्‌विचार मना ।< br />
सत्कर्मे आचरणा । उपयुक्त उद्धरण्या ॥ ३४४ ॥< br />
< br />
श्रीराम जयरामात । सद्‌विचार प्रकटतात ।< br />
सत्कर्मे घडतात । कुकर्मे टळतात ॥ ३४५ ॥< br />
< br />
जीव रमवा नामात । जीव रमवा नामात ।< br />
तेणे निश्चयात । वेळप्रसंगात ॥ ३४६ ॥< br />
< br />
राम राम मुखे म्हणा । तेणे येतो स्थिरपणा ।< br />
तेणे समतोलपणा । उपयुक्त क्षणाक्षणा ॥ ३४७ ॥< br />
< br />
मुखे म्हणा श्रीराम । मनात ठसवा श्रीराम ।< br />
मनःचक्षुसही श्रीराम । दिसता सर्वत्र श्रीराम ॥ ३४८ ॥< br />
< br />
श्रीराम प्रपंचातला । परी न गुरफटला ।< br />
हा बोध नामाने झाला । नका विसरू नामाला ॥ ३४९ ॥< br />
< br />
श्रीरामाच्या नामात । चतुर्मुखे दिसतात ।< br />
भक्तीभाव प्रकटतात । भक्तीभावे जगतात ॥ ३५० ॥< br />
< br />
जो रमतो नामात । तोच रमतो रामात ।< br />
रामच दिसे प्रपंचात । राहातो आनंदात ॥ ३५१ ॥< br />
< br />
रामाचा ध्यास बाळगा । खर्‍या अर्थाने जगा ।< br />
होता नामाच गाजावाजा । होतो श्रीराम जागा ॥ ३५२ ॥< br />
< br />
रामनाम भजावे । चौफेर श्रीराम पहावे ।< br />
रामालाच सोपवावे । तैसेच आचरावे ॥ ३५३ ॥< br />
< br />
श्रीराम भजण्यात । बंधुभाव प्रकटतात ।< br />
तैसा येतो आचरणात । भगवंत संतोषतात ॥ ३५४ ॥< br />
< br />
नामाचा असता सहवास । रामाचे होता दास ।< br />
तेणे न स्त्री हव्यास । रहाता कर्तव्य कर्मास ॥ ३५५ ॥< br />
< br />
रामनाम भजावे । कर्तव्य कर्म करावे ।< br />
सर्व त्याचेच मानावे । प्रारब्ध सोपवावे ॥ ३५६ ॥< br />
< br />
नामाने आळवावे । रामास संतोषावे ।< br />
रामदर्शन व्हावे । जीवन सार्थक व्हावे ॥ ३५७ ॥< br />
< br />
श्रीराम जयराम जयराम । श्रीराम जयराम जयराम ।< br />
मुखी असुद्या रामनाम । श्रीराम जयराम जयराम ॥ ३५८ ॥< br />
< br />
रामनाम भजा भजा । तेणे भय न काळजा ।< br />
काळास म्हणतजा । नको नको तुझी ये जा ॥ ३५९ ॥< br />
< br />
नको क्षण नामाविण । नको क्षण रामाविण ।< br />
रामात होता रममाण । बेचैन रामाविण ॥ ३६० ॥< br />
< br />
रामनामातला राम । दिसतो प्रत्यक्ष राम ।< br />
ऐसे भजता रामनाम । गाठाल मुक्काम ॥ ३६१ ॥< br />
< br />
राहाता रामनामात । आनंदाश्रु नयनात ।< br />
दुःखाश्रु सरतात । सुखदुःखे विरतात ॥ ३६२ ॥< br />
< br />
रामनाम जेथे । आनंद मुक्काम तेथे ।< br />
रामस्वरूप तेथे । खरेखुरे दिसते ॥ ३६३ ॥< br />
< br />
रामनाम भजा । चिंता काळजी वजा ।< br />
दैन्य दुःख वजा । आनंदाची ये जा ॥ ३६४ ॥< br />
< br />
रामाच्या नामात । पतिव्रतेस तोषतात ।< br />
शुभाशिष मिळतात । उपयुक्त ठरतात ॥ ३६५ ॥< br />
< br />
रामनाम म्हणता । संतोषते सीता ।< br />
लक्ष्मणा संतोषता । दारी येतो हनुमंता ॥ ३६६ ॥< br />
< br />
जेथे जेथे रामनाम । तेथे हनुमंत मुक्काम ।< br />
भयभीत काळकाम । आनंद मुक्काम ॥ ३६७ ॥< br />
< br />
रामनाम म्हणण्यात । शुद्ध हेतू मनात ।< br />
सात्विक विचारात । पवित्र आचरणात ॥ ३६८ ॥< br />
< br />
रामनाम भजावे । शुद्ध भाव जागे व्हावे ।< br />
सर्वांभूती राम पहावे । प्रसन्नतेने जगावे ॥ ३६९ ॥< br />
< br />
रामनामोच्चारात । शुद्ध पवित्र अंतरंगात ।< br />
तेच येते आचरणात । सत्‌शीले जगतात ॥ ३७० ॥< br />
< br />
रामनाम भजण्यात । शिवशक्तीही प्रकटतात ।< br />
दुःख संहार करतात । जेथे जेथे प्रकटतात ॥ ३७१ ॥< br />
< br />
रामाचा करता जप । तेणे हरतो भवताप ।< br />
काळाचाही थरकाप । आनंद अमाप ॥ ३७२ ॥< br />
< br />
रामनाम भजा । आनंद वृत्तीने जगा ।< br />
सुखदुःखाच्या बेरजा । आपसुक वजा ॥ ३७३ ॥< br />
< br />
रामनाम मुखे म्हणा । आनंद विलक्षण मना ।< br />
स्वानुभव वदा जना । ऐसा तुम्हां येवो म्हणा ॥ ३७४ ॥< br />
< br />
वदा वदा रामनाम । तेणे चौघांचा मुक्काम ।< br />
आपल्याच घरी ठाम । उपयुक्त रामनाम ॥ ३७५ ॥< br />
< br />
नामाचा सहवास । सुसह्य वनवास ।< br />
प्रत्यक्ष रामास । आले अनुभवास ॥ ३७६ ॥< br />
< br />
नामाचा करता नेम । लाभे भगवंत प्रेम ।< br />
प्रकटतो श्रीराम । करतो मुक्काम ॥ ३७७ ॥< br />
< br />
जो नामव्रत आचरी । तेणे दिसे धनुर्धारी ।< br />
सोबत गदाधारी । तोच भवताप हारी ॥ ३७८ ॥< br />
< br />
राम जन्मला राम । दशरथाचा तो राम ।< br />
दशदिशांचा तो राम । ईच्छापूर्तीचा श्रीराम ॥ ३७९ ॥< br />
< br />
रामजन्म जाहला । सर्वां आनंद झाला ।< br />
भवताप हरण्याला । श्रीराम प्रकटला ॥ ३८० ॥< br />
< br />
श्रद्धेने आळवा श्रीराम । दिसे मूर्तीमंत राम ।< br />
पदोपदी स्मरता राम । जगण्यात वाटे राम ॥ ३८१ ॥< br />
< br />
नामात असता लक्ष । काळकामाचे न भक्ष्य ।< br />
नामाशी करता सख्य । राहाता हंसतमुख ॥ ३८२ ॥< br />
< br />
नामाचे अनुसंधान । ठरते वरदान ।< br />
भगवंत आपणहुन । करतो भक्त रक्षण ॥ ३८३ ॥< br />
< br />
नामाचे व्हावे आपण । व्हावे त्यात रममाण ।< br />
देहभान विसरून । करावे नामस्मरण ॥ ३८४ ॥< br />
< br />
तल्लीन व्हावे नामात । एकरूप व्हावे नामात ।< br />
पहाल भगवंत । एकरूप होण्यात ॥ ३८५ ॥< br />
< br />
नामातली एकरूपता । प्रसन्न करते चित्ता ।< br />
मनास प्रफुल्लता । नामानेच साधता ॥ ३८६ ॥< br />
< br />
नामात तुम्ही रमता । साधता एकरूपता ।< br />
त्यात रममाण होता । प्राप्त करता भगवंता ॥ ३८७ ॥< br />
< br />
आम्ही नामाचे नामाचे । हेच सदा म्हणायचे ।< br />
तेणे व्हावे भगवंताचे । न व्हावे दुसर्‍याचे ॥ ३८८ ॥< br />
< br />
भगवंताचे नाम । शांती समाधान ठाम ।< br />
तेणे चैतन्य धाम । सानंदस्वरूप धाम ॥ ३८९ ॥< br />
< br />
नामाची महती । नामच दावे प्रचीती ।< br />
नामात रमता अती । तेणे भगवत् प्राप्ती ॥ ३९० ॥< br />
< br />
नामाचा असावा ध्यास । त्यात रमावे तास नि तास ।< br />
तेणे भगवंतास । प्राप्त कराल हमखास ॥ ३९१ ॥< br />
< br />
रंगा रंगा नामात । नामाने रंगा त्यात ।< br />
रंगावे सर्वात । असुनी नामात ॥ ३९२ ॥< br />
< br />
नामात होता रंग । रंगाने पहाता रंग ।< br />
जीवनातले रंग । दावतो श्रीरंग ॥ ३९३ ॥< br />
< br />
रंगा रंगा नामात । नामाच्या रंगात ।< br />
रंग दिसे प्रत्यक्षात । विविध रूपात ॥ ३९४ ॥< br />
< br />
रंग रंग नामाचा । तेणे प्रकाश ज्ञानाचा ।< br />
नाश अज्ञानाचा । ऐसा प्रभाव नामाचा ॥ ३९५ ॥< br />
< br />
नामाने रंगावे रंगात । रंग येतो पुढ्यात ।< br />
तोच रमवे नामात । रंगले रंग नामात ॥ ३९६ ॥< br />
< br />
नामात होता रंग । रंगच रंगवे रंग । < br />
नामाचा ऐसा रंग । तोषे अवधूत रंग ॥ ३९७ ॥< br />
< br />
रंगून जावे रंगात । तेणे अवधूत रंगात ।< br />
तोषे नामाच्या रंगात । रंगुन जातो नामात ॥ ३९८ ॥< br />
< br />
रंग रंग नामाचा । ऐसा महिमा रंगाचा ।< br />
रंगाने नाम रंगाचा । योग भाग्याचा ॥ ३९९ ॥< br />
< br />
नामात सदा रमावे । तेणे नाममय व्हावे ।< br />
प्रारब्ध सोपवावे । निश्चिंत असावे ॥ ४०० ॥< br />
< br />
नाम जितुके आळवाल । तितुके त्यात रमाल ।< br />
नामाने आचराल । सत्पथ वाटचाल ॥ ४०१ ॥< br />
< br />
नाममय होता । भगवंतमय होता ।< br />
तो जवळ येता । भवभय न चित्ता ॥ ४०२ ॥< br />
< br />
नामाला करता जवळ । तेणे निश्चय जवळ ।< br />
वाढे निश्चयाचे बळ । तेणे निश्चित फळ ॥ ४०३ ॥< br />
< br />
नामाला जवळ करावे । नामातच रमावे ।< br />
 नामाचेच ऐकावे । नामानेच तरावे ॥ ४०४ ॥< br />
< br />
नामाचा लावता वशीला । भगवंत होतो आपला ।< br />
तेणे ताप प्रपंचातला । न जाळे चित्ताला ॥ ४०५ ॥< br />
< br />
नामाशी जडता नाते । चिंता काळजी हरते ।< br />
भवभय न उरते । सर्व आनंदमय दिसते ॥ ४०६ ॥< br />
< br />
नाते जडता नामाशी । चिंता काळजी न उराशी । < br />
नाते जडता आनंदाशी । नाते जडते भगवंताशी ॥ ४०७ ॥< br />
< br />
नामाशी नाते जोडा । तेणे भगवंत जोडा ।< br />
तेणे भवभय सोडा । तेणे आनंद जोडा ॥ ४०८ ॥< br />
< br />
नामाशी नाते जोडता । तेणे सुटतो गुंता ।< br />
नामात चित्त गुंतता । हरे भवताप चिंता ॥ ४०९ ॥< br />
< br />
नामासारखा सोबती । नाही कुणी ह्या जगती ।< br />
कुठचीही येता परिस्थिती । समतोल राहाता चित्ती ॥ ४१० ॥< br />
< br />
नामाने जे अनुभवता । पुढिल प्रसंगी त्राता ।< br />
नाम घेता येता जाता । आपत्काळी तरता ॥ ४११ ॥< br />
< br />
नका करू मनाचे लाड । नका जपु जीवापाड ।< br />
नामाचे करावे लाड । नामास जपावे जीवापाड ॥ ४१२ ॥< br />
< br />
नको भटकु मना । नको गुरफटु मना ।< br />
नको दुबळेपणा । नको जगु नामाविणा ॥ ४१३ ॥< br />
< br />
नामाशी करावे सख्य । तेणे ने पदरी दुःख ।< br />
रहाल सदा हसतमुख । हेच जीवनाचे सुख ॥ ४१४ ॥< br />
< br />
सुखदुःख जे मानता । तेणेच दुःखी होता ।< br />
नामाशी नाते जोडता । सुख दुःखे विसरता ॥ ४१५ ॥< br />
< br />
नामाशी नाते जोडावे । सुखसुःख विसरावे ।< br />
नामातच धुंद व्हावे । सर्वांत भगवंत पहावे ॥ ४१६ ॥< br />
< br />
कनक आणि कांता । हीच जाळते चित्ता ।< br />
त्याच्यात अती रमता । उध्वस्त होता ॥ ४१७ ॥< br />
< br />
कनक आणि कांता । नामाशी जोडता ।< br />
नामावर सोपवता । जीवनी तरता ॥ ४१८ ॥< br />
< br />
कनक कांतेचा मोह । कधी न हितावह ।< br />
तेणे न तरला भव । न तरणार भव ॥ ४१९ ॥< br />
< br />
कनक कांतेचा मोह । तेणे सदा भय ।< br />
नामात रमवता जीव । तेणे निर्भय ॥ ४२० ॥< br />
< br />
कनक कांता ऐशी । संबंध मोहमायेशी ।< br />
सदा त्यांचे पाशी । चिंता काळजी उराशी ॥ ४२१ ॥< br />
< br />
नका चिंतु विषय । नाम चिंतावे अक्षय ।< br />
विषये चिंता काळजी भय । नामाने बने निर्भय ॥ ४२२ ॥< br />
< br />
नको विषय चिंतन । विषयाने दाणादाण ।< br />
नामात व्हावे रममाण । नामाने आनंद समाधान ॥ ४२३ ॥< br />
< br />
नको विषयाचे दास । तेणे आनंदाचा र्‍हास ।< br />
नामाचे होता दास । सदा आनंद उल्हास ॥ ४२४ ॥< br />
< br />
विषयी गुंतता मती । तेणे होते अधोगती ।< br />
नाम असता मुखावरती । तेणे साधता प्रगती ॥ ४२५ ॥< br />
< br />
विषय वाईट अत्यंत । सर्वच बुडाले विषयात ।< br />
परी राहात नामात । तरता भवसागरात ॥ ४२६ ॥< br />
< br />
विषयात धुंद होता । चित्ती अस्वस्थता ।< br />
नामात धुंद होता । चित्ती प्रसन्नता ॥ ४२७ ॥< br />
< br />
विषय सेवावा मोजका । तोल सावरण्या इतुका । < br />
वेळी अवेळी नाम मुखा । उपयुक्त न नामाइतुका ॥ ४२८ ॥< br />
< br />
कनक कांता केवढे ? । अत्यावश्यकता एवढे ।< br />
त्यातच होता वेडे । चिंता काळजीचे वेढे ॥ ४२९ ॥< br />
< br />
कांता नि कनक । मोह मायेचे जनक ।< br />
असता अनावश्यक । जीवन निरर्थक ॥ ४३० ॥< br />
< br />
नामाचे सुत कातावे । त्याचेच धागे विणावे ।< br />
त्याचेच वस्त्र ल्यावे । आत्म्यास तोषावावे ॥ ४३१ ॥< br />
< br />
विविध वस्त्रे जगती । सदा चित्त आकर्षिती ।< br />
परी नामवस्त्रांवरती । शांती समाधान चित्ती ॥ ४३२ ॥< br />
< br />
नको वैभव उसने । मनोराज्य करणे ।< br />
नाम परिधान करणे । हेच हितावह असणे ॥ ४३३ ॥< br />
< br />
नामाचे वस्त्र ऐसे । स्वकमाईचे दिसे ।< br />
स्वानुभवे जगतसे । खात्रीचा मार्ग असे ॥ ४३४ ॥< br />
< br />
नामाच्या वस्त्रात । आनंदाच्या धाग्यात ।< br />
तेच परिधानात । अर्पण सुख भावात ॥ ४३५ ॥< br />
< br />
नामाच्या वस्त्रांवर । संतुष्ट परमेश्वर ।< br />
तेच त्याला अर्पिल्यावर । संतोषे परमेश्वर ॥ ४३६ ॥< br />
< br />
नामाचे धागे सुखाचे । खर्‍याखुर्‍या आत्मसुखाचे ।< br />
लवलेश न दुःखाचे । हेच बोल अनुभवाचे ॥ ४३७ ॥< br />
< br />
एकेक धागा नामाचा । ‘तो’ स्वये गुंफण्याचा ।< br />
‘तो’च होता प्राप्तीचा । तोच क्षण भाग्याचा ॥ ४३८ ॥< br />
< br />
आपल्या भाग्यात अनेक । नाही नामासारखे एक ।< br />
होता नाममयच । काही न मागणे शिल्लक ॥ ४३९ ॥< br />
< br />
नामाचे वस्त्र जाडे साधे । नात्याचे धागे बांधे ।< br />
तेच भगवंता आवडे । जगण्याचा हेतु साधे ॥ ४४० ॥< br />
< br />
नामाच्या विविध छटा । आनंद धाग्याचा सांठा ।< br />
ऐसे परिधान करता । आनंदी आनंदे जगता ॥ ४४१ ॥< br />
< br />
नामवस्त्र परिधानात । बेअब्रु न होण्यात । < br />
सार्‍या जगा दावतात । सारे अनुसरतात ॥ ४४२ ॥< br />
< br />
आम्ही झालो नामाचे । आता न कारण भितीचे ।< br />
आता नामाचे पहायचे । आता नामाने जगायचे ॥ ४४३ ॥< br />
< br />
‘मी’ ने जे जे केले । ते काही व्यर्थ ठरले ।< br />
नामाने जे सांगितले । अनुसरण्या हीत झाले ॥ ४४४ ॥< br />
< br />
आधी करावे नामस्मरण । नको नुसते चिंतन ।< br />
तैसे होता आचरण । फलदायी नामस्मरण ॥ ४४५ ॥< br />
< br />
नाम जे जे सांगेल । तेच हितावह ठरेल ।< br />
हे जेव्हा मना पटेल । तेव्हा मनःशांती लाभेल ॥ ४४६ ॥< br />
< br />
नाम आनंदासाठी । न नुसत्या चिंतनासाठी ।< br />
नाम आचरणासाठी । मनःशांती साठी ॥ ४४७ ॥< br />
< br />
आनंद आहे नामात । दडुन बसला त्यात ।< br />
प्रेरणेने आचरणात । मिळवाल निश्चित ॥ ४४८ ॥< br />
< br />
नामातला एकेक पळ । देण्या आनंद सकळ ।< br />
परी विरुद्ध आचराल । न काही मिळवाल  ॥ ४४९ ॥< br />
< br />
नामामुळे सर्व कळते । परी वागण्या दुःख होते ।< br />
नामावर खात्री नसते । तेथे ऐसेच घडते ॥ ४५० ॥< br />
< br />
नामाने न होणार दुःख । तेणे आनंदमुख ।< br />
‘मी’ ची होता जवळीक । सर्वात दिसते दुःख ॥ ४५१ ॥< br />
< br />
नामावर भरंवसा ठेवा । हाच प्रयोग करावा ।< br />
तैसा मार्ग आक्रमावा । नित्यनेम करावा ॥ ४५२ ॥< br />
< br />
नुसत्या चिंतनाने निष्फळ । जैसी बडबड वायफळ ।< br />
नामाने जे आचराल । आनंदच मिळवाल ॥ ४५३ ॥< br />
< br />
आनंद म्हणजे परमेश्वर । व्याप्त केले चराचर ।< br />
भरंवसा ठेवा नामावर । आनंद होईल साकार ॥ ४५४ ॥< br />
< br />
नामास करता जवळ । काढाल मनाचा मळ ।< br />
तो निघता सकळ । आनंदच दिसेल ॥ ४५५ ॥< br />
< br />
मनावरची एकेक पुटे । नामच दूर करते ।< br />
नाम जवळ करण्याते । मन स्वच्छ होते ॥ ४५६ ॥< br />
< br />
नाम ऐसे साधन । उपयुक्त क्षणोक्षण ।< br />
मळपुटे दूर करुन । ठेवले स्वच्छ मन ॥ ४५७ ॥< br />
< br />
नाम ऐसे द्रावण । न सांडे एकही कण ।< br />
कुठेही उपयुक्त साधन । स्वच्छ करेल मन ॥ ४५८ ॥< br />
< br />
जे जे गढुळ मनात । ते ते कळते नामात ।< br />
गढुळ दूर करण्यात । नामच ठरे श्रेष्ठ ॥ ४५९ ॥< br />
< br />
शुद्ध आणि गढुळ । नामात कळे सकळ ।< br />
पळे दूर गढुळ । नाम येता जवळ ॥ ४६० ॥< br />
< br />
नामाचा आधार मोठा । नामच प्रसंगी त्राता ।< br />
नाम श्रद्धेने भजता । चिंता क्लेश विसरता ॥ ४६१ ॥< br />
< br />
नाम भजावे नाम । भगवंताचे नाम ।< br />
निश्चय करा ठाम । भगवंताचा मुक्काम ॥ ४६२ ॥< br />
< br />
श्रद्धेने नाम भजावे । श्रद्धेने पाऊल टाकावे ।< br />
श्रद्धेत हीत मानावे । अश्रद्धेने न जगावे ॥ ४६३ ॥< br />
< br />
नामावर श्रद्धा बाळगा । नको चिंता काळजी उगा ।< br />
नामाने खात्रीने जगा । तेणे भय न काळजा ॥ ४६४ ॥< br />
< br />
नामात नित्य रमावे । नित्य अनित्य ओळखावे ।< br />
नित्यात मन गुंतवावे । तेच हीत समजावे ॥ ४६५ ॥< br />
< br />
नारायण आम्हां देतो । नामात बोध होतो ।< br />
जो नारायण स्मरतो । आनंद वृत्तीने जगतो ॥ ४६६ ॥< br />
< br />
नामावर श्रद्धा ठेवा । नामाचा नेम करावा ।< br />
नामानेच आळवावा । हीच भगवंत सेवा ॥ ४६७ ॥< br />
< br />
नामास जवळ करता । ‘त्यास’ जवळ करता ।< br />
नामास दूर लोटता । ‘त्यास’ दूर लोटता ॥ ४६८ ॥< br />
< br />
नामास जवळ करावे । नित्य नाम स्मरावे ।< br />
नामात हित मानावे । गुरू बोल ऐकावे ॥ ४६९ ॥< br />
< br />
नामच खरा सखा । नोच खरा पाठीराखा ।< br />
तोच तारे सुखदुःखा । नाही कुणी नामासारखा ॥ ४७० ॥< br />
< br />
नामा तुझी ऐशी महती । जे जे नामात रमती ।< br />
सुखदुःखे विसरती । सुखदुःखा न महत्व देती ॥ ४७१ ॥< br />
< br />
नाम घ्या हो नाम । भगवंताचे नाम ।< br />
तेणे आनंद मुक्काम । तेणे आनंदधाम ॥ ४७२ ॥< br />
< br />
मुखे नाम किती घ्यावे ? । ज्याने त्याने ठरवावे ।< br />
नाम शाश्वतास दावे । अशाश्वतास घालवे ॥ ४७३ ॥< br />
< br />
नामे लाभते शाश्वत । गुंतते मन शाश्वतात । < br />
लोप पावते अशाश्वत । हीच किमया नामात ॥ ४७४ ॥< br />
< br />
नामात जे जे मिळते । ते शाश्वतावर असते ।< br />
शाश्वताची गोडी लागते । शाश्वतात मन रमते ॥ ४७५ ॥< br />
< br />
नामात तुम्ही रहाता । शाश्वताशी नाते जोडता ।< br />
शाश्वतास जवळ करता । भगवंतास जवळ करता ॥ ४७६ ॥< br />
< br />
जीव रमवा नामात । नामच उपयुक्त सर्वात ।< br />
नाम असता मुखात । जीव राहातो आनंदात ॥ ४७७ ॥< br />
< br />
सदा नाम श्रद्धेने घ्या । श्रद्धेने भरा खळगा ।< br />
तेणे न काळजी काळजा । चिंता भय होते वजा ॥ ४७८ ॥< br />
< br />
नामास कळते पुढचे । नामच सांगे हिताचे ।< br />
जेथे स्मरण नामाचे । तेथे भय न काळजीचे ॥ ४७९ ॥< br />
< br />
गुरू आज्ञेत हित मानावे । गोरे काळे विसरावे ।< br />
नामाच्या तालात जगावे । नामावरच सोपवावे ॥ ४८० ॥< br />
< br />
नामाचा होता धूर । विषय पळती दूर ।< br />
चित्तातली हुरहुर । होते सर्वथा दूर ॥ ४८१ ॥< br />
< br />
नामाचा धूर करावा । तेणे विषय घालवावा ।< br />
विषय न पोसावा । तोल सदा सावरावा ॥ ४८२ ॥< br />
< br />
नाम सदा अक्षय । क्षणभंगुर विषय ।< br />
नाम सदा आनंदमय । विषय सदा दुःखमय ॥ ४८३ ॥< br />
< br />
नाम खरा खुरा शाश्वत । विषय सदा अशाश्वत ।< br />
नामात होते स्थिर चित्त । विषयात अस्थिर चित्त ॥ ४८४ ॥< br />
< br />
नाम स्थिर नि शांत । विषय अस्थिर अशांत ।< br />
नामात चित्त शांत । विषयी चित्त अशांत ॥ ४८५ ॥< br />
< br />
विषयाने तोल जातो । नामाने सावरला जातो ।< br />
विषयात घसरतो । नामात उद्धरतो ॥ ४८६ ॥< br />
< br />
विषय हवाहवासा वाटतो । तेणेच घात होतो ।< br />
नामात विषय दूर जातो । नामाचा आधार वाटतो ॥ ४८७ ॥< br />
< br />
अती विषय घातक । तेणे महापातक ।< br />
नामस्मरण तारक । नाम पाप विनाशक ॥ ४८८ ॥< br />
< br />
विषय दुःखकारक । सदा पीडादायक ।< br />
नाम सुखकारक । सदा मंगलदायक ॥ ४८९ ॥< br />
< br />
विषय विघ्नकारक । नाम विघ्नहारक ।< br />
विषय हानीकारक । नाम लाभदायक ॥ ४९० ॥< br />
< br />
नको विषय फाजील । चित्तास सदा जाळतील ।< br />
नामात तरशील । अनुभवच बोलशील ॥ ४९१ ॥< br />
< br />
कुणी न तरला भव । हा विषय अनुभव ।< br />
नामात तरती भव । हा खात्रीचा अनुभव ॥ ४९२ ॥< br />
< br />
नामाचा लळा लागता । हा जीव रमु लागला ।< br />
स्मरता तुझ्या लीला । आनंद वाटे मला ॥ ४९३ ॥< br />
< br />
नामा ! तूच दावतो । आनंद कोठे वसतो ! ।< br />
जो जो स्मरण करतो । तो आनंदात राहातो ॥ ४९४ ॥< br />
< br />
जेथे नामाचा वास । तेथे आनंद सहवास ।< br />
जेथे आनंद वास । तेथे भगवंत वास ॥ ४९५ ॥< br />
< br />
नामा तुझ्यावर आता । वाटे विसंबावे आता ।< br />
तुझ्यावर ठेवता निष्ठा । मला न काळजी चिंता ॥ ४९६ ॥< br />
< br />
नामा तुझ्या सारखा । तुच सदा पाठीराखा ।< br />
खर्‍या अर्थाने तू सखा । म्हणे तरशील लेका ॥ ४९७ ॥< br />
< br />
नाम माझा सखा खरा । नामच माझा आसरा ।< br />
नाम असता माझ्या घरा । सदानंद माझ्या घरा ॥ ४९८ ॥< br />
< br />
नाम घ्या हो नाम । आनंद शांतीचे नाम ।< br />
भजता हरीचे नाम । आनंद शांती मुक्काम ॥ ४९९ ॥< br />
< br />
नामात जीव रमवा । चिंता क्लेशास घालवा ।< br />
अंतरात्म्यास तोषवा । परमात्म्यास तोषवा ॥ ५०० ॥< br />
< br />
नाम येता ओठावरी । हरी दिसे ओसरीवरी ।< br />
आनंद येतो घरी । हरीच्या बरोबरी ॥ ५०१ ॥< br />
< br />
नामात रंगुन जावे । हरी स्मरणात रंगावे ।< br />
हरीलाच सोपवावे । सारे तुझेच म्हणावे ॥ ५०२ ॥< br />
< br />
नाम आळवा नाम । भगवंता प्रिय नाम ।< br />
जेथे जेथे त्याचे नाम । तेथे त्याचा मुक्काम ॥ ५०३ ॥< br />
< br />
नाम ऐसे आळवावे । भगवंताने ऐकावे ।< br />
भगवंताने तल्लीन व्हावे । ऐसे नाम भजावे ॥ ५०४ ॥< br />
< br />
भगवंत तोषे नामात । नाही नुसत्या वैभवात ।< br />
नामावाचुन वैभवात । तेणे आत्म्यावाचुन देहात ॥ ५०५ ॥< br />
< br />
नामास आत्मा समजा । त्याचीच करा पूजा ।< br />
येता जाता नाम भजा । अंतरात्म्याकडे बघा ॥ ५०६ ॥< br />
< br />
येता जाता नाम भजता । नाममयच होता ।< br />
चिंता काळजी मुक्त होता । नाम मुखी येता ॥ ५०७ ॥< br />
< br />
जे न मिळे वैभवात । त्याहुन अधिक नामात ।< br />
नाम ज्याच्या मुखात । लोणीसाखर मुखात ॥ ५०८ ॥< br />
< br />
नाम ज्याच्या मुखात । मृदुता संभाषणात ।< br />
क्लीष्टता पळे पळात । मधुरता येई शब्दात ॥ ५०९ ॥< br />
< br />
नामाचे अलंकार घाला । भूषवावे देहाला ।< br />
भगवंत भुले नामाला । हेच येते अनुभवाला ॥ ५१० ॥< br />
< br />
नामा तुला काय कळते ? । म्हणणे मूर्खाचे होते ।< br />
जे आपणांस न कळते । ते नामास कळते ॥ ५११ ॥< br />
< br />
नाम म्हणजे काय ? । नाम म्हणजे तरणोपाय ।< br />
नामास म्हणावे माय । हांक मारता होते धाव ॥ ५१२ ॥< br />
< br />
नाम म्हणजे माऊली । सदा कृपेची सावली ।< br />
नामाच्या छत्राखाली । भवताप न जाळी ॥ ५१३ ॥< br />
< br />
नामास माऊली म्हणावे । नामास आधार मानावे ।< br />
नामाचेच ऐकावे । जीवन सार्थक करावे ॥ ५१४ ॥< br />
< br />
नाम ओळखे माया । म्हणे नको सतावु बया ।< br />
तान्हुल्यांच्या जीवा । जाळु नकोस बया ॥ ५१५ ॥< br />
< br />
नाम माया ओळखते । मायेस परतवते ।< br />
माया पुढे येण्याते । नामास घाबरते ॥ ५१६ ॥< br />
< br />
नाम म्हणजे माता । भवसागर त्राता ।< br />
येता जाता भजता । भयमुक्त होता ॥ ५१७ ॥< br />
< br />
नामाची आज्ञा पाळा । तेणे तोषवा गोपाळा ।< br />
नाम जपते तान्हुल्या । दावते वात्सल्या ॥ ५१८ ॥< br />
< br />
नामास माता म्हणता । खर्‍या अर्थी जगता ।< br />
नामाची आज्ञा पाळता । भगवंत तोषता ॥ ५१९ ॥< br />
< br />
नामाचे लेकरू आपण । नामाचे वाक्य प्रमाण ।< br />
नामाविण जीवन । म्हणजे पोरकेपण ॥ ५२० ॥< br />
< br />
नामाने पोसले आपणा । विसरु नका एकेक क्षणा ।< br />
जगु नका स्मरणाविणा । नको नको कृतघ्नपणा ॥ ५२१ ॥< br />
< br />
नाम जगत्‌ जननी । आनंदाची जननी ।< br />
नाही थोर झाले कुणी । नाम जननी वाचुनी ॥ ५२२ ॥< br />
< br />
नामाची सेवा करा । तोच तरणोपाय खरा ।< br />
नामाचा घेता आसरा । रोज दिवाळी दसरा ॥ ५२३ ॥< br />
< br />
सेवा करा नामाची । तेणे सेवा भगवंताची ।< br />
भगवंता तोषण्याची । किमया आहे नामाची ॥ ५२४ ॥< br />
< br />
जो नामात रंगतो । तो वैकुंठात जातो ।< br />
नरदेहाचे सोने करतो । मरणोत्तरही जगतो ॥ ५२५ ॥< br />
< br />
नामानेच खरे जगता । कळते नाम भजता ।< br />
नाम घेता येता जाता । मोह माया जिंकता ॥ ५२६ ॥< br />
< br />
जो नामात असतो । तो तोल सावरतो ।< br />
जो नाममय होतो । तोच पुढे जातो ॥ ५२७ ॥< br />
< br />
नामात ऐसे रंगावे । भगवंताने थक्क व्हावे ।< br />
तेणे स्वयेच पुढे यावे । कृपाशिष द्यावे ॥ ५२८ ॥< br />
< br />
नामात जीव रमवता । कृपाशिष मिळवता ।< br />
तेणे जीवा उद्धरता । पैलतीर गाठता ॥ ५२९ ॥< br />
< br />
येता जाता घेता नाम । तेणे ज्ञानाचा मुक्काम ।< br />
अज्ञानास रामराम । जगण्यात खरा राम ॥ ५३० ॥< br />
< br />
नामास हरघडी भजता । हरघडीस हरी पहाता ।< br />
त्याच्यात धुंद होता । सभोवताल विसरता ॥ ५३१ ॥< br />
< br />
रमा रमा हरीनामात । हरघडी रमा त्यात ।< br />
हरीच्या नामोच्चारात । हरीच येतो पुढ्यात ॥ ५३२ ॥< br />
< br />
हरीस सदा भजावे । हरी हरी म्हणावे ।< br />
हरीने सत्वर यावे । चिंतेस मुक्त करावे ॥ ५३३ ॥< br />
< br />
नामाचे आपण होता । हरीचे आपण होता ।< br />
आपण हरीमय होता । हरी हरीच म्हणता ॥ ५३४ ॥< br />
< br />
नामात धुंद व्हावे सदा । तेणे भेटतो ‘सदा’ ।< br />
नामाशी असता सदा । तेणे पाठीशी सदा ॥ ५३५ ॥< br />
< br />
नामाशी होता एकरूप । पहाता एकरूप ।< br />
चित्ती ठासता एकरूप । पहाता एकरूप ॥ ५३६ ॥< br />
< br />
एकरूप व्हावे नामाशी । तेणे विविध रूपांशी ।< br />
एकरूप होता त्याशी । आनंदाच्या राशी ॥ ५३७ ॥< br />
< br />
नामाशी एकरूप व्हावे । एकात धुंद व्हावे ।< br />
अनेकात एक पहावे । एकात अनेक पहावे ॥ ५३८ ॥< br />
< br />
नामाशी एकरूप होता । नामाचे बोल बोलता ।< br />
त्यातच रम्गुन जाता । विविध रंग पहाता ॥ ५३९ ॥< br />
< br />
नामात रंगुन जाण्यात । त्याला रंगुन टाकतात ।< br />
दोघे जेव्हा रंगतात । फळे फुले बहरतात ॥ ५४० ॥< br />
< br />
नामात रंगुन जावे । नामानेच रंगवावे ।< br />
त्याने प्रफुल्लित व्हावे । आपणासही रंगवावे ॥ ५४१ ॥< br />
< br />
नामाच्या एकरूपतेत । रहाता प्रसन्नतेत ।< br />
कधी न चिंता व्यथेत । काळजी उद्विग्नतेत ॥ ५४२ ॥< br />
< br />
नामाचे बोल बोलता । अपशब्द टाळता ।< br />
मधुर बोल बोलता । मधुर फळे चाखता ॥ ५४३ ॥< br />
< br />
नामाची गोडी ऐशी । सहाता अमृताशी ।< br />
गोडी चाखता ऐशी । रहाता सदा नामाशी ॥ ५४४ ॥< br />
< br />
नामाचे बोल मधुर । मुळातच नाम मधुर ।< br />
नामाचे बी मधुर । तेणे फळेही मधुर ॥ ५४५ ॥< br />
< br />
नामास जवळ करता । जीवनी मधुरता ।< br />
जरी येता कटुता । मधुरच म्हणता ॥ ५४६ ॥< br />
< br />
नामाची किमया ऐशी । ती वर्णावि कैसी ? ।< br />
आनंदाच्या इतुक्या राशी । काय मोजणार त्यासी ? ॥ ५४७ ॥< br />
< br />
नामात ऐसे रंगावे । मोजमाप नसावे ।< br />
अहर्निश भजावे । अहर्निश रंगावे ॥ ५४८ ॥< br />
< br />
नामात धुंद होता । भगवंत वृंद पहाता ।< br />
त्यातच धुंद होता । आनंद वृंद पहाता ॥ ५४९ ॥< br />
< br />
येता जाता नाम म्हणता । आनंद आनंद म्हणता ।< br />
त्याशी एकरूप होता । आनंदमय होता ॥ ५५० ॥< br />
< br />
नामात वसला आनंद । तेणे नामात आनंद ।< br />
नामात मिळता आनंद । भेटतो सदानंद ॥ ५५१ ॥< br />
< br />
ऐसे नाम आळवावे । नयनाश्रु ओघळावे ।< br />
आनंदाश्रु समजावे । आनंद अनुभवावे ॥ ५५२ ॥< br />
< br />
नाम नाम भजता । निर्गुणास भजता ।< br />
ऐसे नाम भजता । ‘त्यास’ सगुण करता ॥ ५५३ ॥< br />
< br />
ऐसे नाम भजावे । निर्गुण सगुण व्हावे ।< br />
ऐसे निर्गुण वर्णावे । सगुणच वाटावे ॥ ५५४ ॥< br />
< br />
नाम घेता निर्गुणाचे । गुण गाता सगुणाचे ।< br />
नाम घेता सगुणाचे । तेणे होता निर्गुणाचे ॥ ५५५ ॥< br />
< br />
नाम येता मुखाते । निर्गुण सगुण कळते ।< br />
दोन्ही अनुभवण्याते । खरे खुरे कळते ॥ ५५६ ॥< br />
< br />
निर्गुणाचे नाम घेता । त्यास सगुण करता ।< br />
सगुणाचे नाम घेता । निर्गुणमय होता ॥ ५५७ ॥< br />
< br />
नाम घेता सगुणाचे । अनुभव निर्गुणाचे ।< br />
गुण गाता त्याचे । अनुभव आनंदाचे ॥ ५५८ ॥< br />
< br />
प्रभु नाम भजता । काळ काम विसरता ।< br />
नाममय होता । भूक तहान विसरता ॥ ५५९ ॥< br />
< br />
नाम येता मुखाने । आनंदाचे येते भरते ।< br />
तेणे तहान शमते । भूक पार विसरते ॥ ५६० ॥< br />
< br />
नामात ऐसे रंगावे । प्रभु नामच दिसावे ।< br />
रूपही अदृष्य व्हावे । निर्गुणमय व्हावे ॥ ५६१ ॥< br />
< br />
नामाशी नाते जोडता । निर्गुणास जोडता ।< br />
त्यास सर्वांत पहाता । निर्गुणमय होता ॥ ५६२ ॥< br />
< br />
होता नाममय । होता निर्गुणमय ।< br />
सगुणाचे काय ? । त्याचे त्याला ठाव ॥ ५६३ ॥< br />
< br />
नाममय होता आपण । सगुण होतो निर्गुण ।< br />
निर्गुणाचे गाता गुण । पुन्हा होतो सगुण ॥ ५६४ ॥< br />
< br />
नामात साधता । आनंद स्वरूपता ।< br />
जितुकी एकरूपता । तितुका अनुभवता ॥ ५६५ ॥< br />
< br />
नामात एकरूप व्हा । तेणे आनंद मिळवा ।< br />
त्यातच तल्लीन व्हा । सत्स्वरूप पहा ॥ ५६६ ॥< br />
< br />
सामात काय मिळते ! । नामात सर्व मिळते ।< br />
आनंद प्राप्त होण्याते । काय न मिळते ? ॥ ५६७ ॥< br />
< br />
नामात एकरूपता साधा । तेणे आनंद साधा ।< br />
तेणे परमार्थ साधा । तेणे सर्व साधा ॥ ५६८ ॥< br />
< br />
नामात होता एकरूप । पहाता चित्‌स्वरूप ।< br />
पहाता अरूप स्वरूप । पहाता भगवंत स्वरूप ॥ ५६९ ॥< br />
< br />
एकरूप होता नामात । तेणे रहाता आनंदात ।< br />
भवदुःख न जाणवतात । आपण रमता नामात ॥ ५७० ॥< br />
< br />
नामात एकरूप होता । फक्त नामच पहाता ।< br />
त्यात स्वरूप दिसता । मिळे आनंद चित्ता ॥ ५७१ ॥< br />
< br />
नामात एकरूप व्हावे । नाममय व्हावे ।< br />
आनंदस्वरूप पहावे । आनंदमय व्हावे ॥ ५७२ ॥< br />
< br />
नामात साधा एकरूपता । आनंद प्राप्त करता ।< br />
त्यात एकरूप होता । नाममयच होता ॥ ५७३ ॥< br />
< br />
नामात एकरूपता साधता । सभोवताल विसरता ।< br />
भवदुःख विसरता । आनंद प्राप्त करता ॥ ५७४ ॥< br />
< br />
नामाशी एकरूप व्हावे । तेणे एकरूप पहावे ।< br />
आनंद अनुभवावे । स्वानुभव घ्यावे ॥ ५७५ ॥< br />
< br />
एकरूप होता नामाशी । आनंदाच्या राशी ।< br />
येतात आपणापाशी । आनंद देण्यासी ॥ ५७६ ॥< br />
< br />
एकरूप व्हावे नामात । तेणे सदा आनंदात ।< br />
सुखसुःखे विरतात । रहाता नामात ॥ ५७७ ॥< br />
< br />
एकरूप व्हा नामात । एकरूप व्हा एकरूपात ।< br />
एकरूप व्हा आनंदात । एकरूपता सर्वात ॥ ५७८ ॥< br />
< br />
नको नुसते नामात । एकरूपता हवी त्यात ।< br />
एकरूपे वीण नामात । काहुर माजतात ॥ ५७९ ॥< br />
< br />
नाम आणि एकरूपता । ह्यांचे नाते जडता ।< br />
कमी होते जडता । एकरूप जडता ॥ ५८० ॥< br />
< br />
नामात जडते एकरूप । जडता एकरूप ।< br />
पहाता चित्‌स्वरूप । पहाता आनंदरूप ॥ ५८१ ॥< br />
< br />
नामात एकरूपता जडता । कळु लागते जडता ।< br />
जडता पार विसरता । एकरूपाशी जडता ॥ ५८२ ॥< br />
< br />
नामात एकरूप जडते । जडता जड होते ।< br />
जडता तळाशी बसते । कधी न वर येते ॥ ५८३ ॥< br />
< br />
नामात एकरूप होता । जडता विसरता ।< br />
जडता घालवता । एकरूप जडता ॥ ५८४ ॥< br />
< br />
नामाच्या एकरूपतेत । रहाता ‘एकरूपतेत’ ।< br />
जडण्या एकरूपतेत । न रहात जडतेत ॥ ५८५ ॥< br />
< br />
नामाची सोबत ऐशी । सदा असते पाठीशी ।< br />
नाम असता मुखाशी । चिंता काळजी न उराशी ॥ ५८६ ॥< br />
< br />
नामाची असता सोबत । ऐकता आनंद नौबत ।< br />
आनंद होता ओतप्रोत । ज्ञान प्रकाशाचा झोत ॥ ५८७ ॥< br />
< br />
नामाची सोबत करावी । ती आधार मानावी ।< br />
चिंता काळजीस घालवी । तेणे आनंद पालवी ॥ ५८८ ॥< br />
< br />
सोबत असावी नामाची । खरी जरूर त्याची ।< br />
निराशा, सुखदुःखाची । मात्रा न चालायची ॥ ५८९ ॥< br />
< br />
हरी नाम खरे सोबती । तेणे हरी सोबती ।< br />
चिंता भय न चित्ती । हरी सांठता चित्ती ॥ ५९० ॥< br />
< br />
नामाची सोबत खरीखुरी । चिंता काळजी न उरी ।< br />
चिंता पळते दूरवरी । येता नाम मुखावरी ॥ ५९१ ॥< br />
< br />
नामाची सोबत असावी । त्याची कांस धरावी ।< br />
ऐशी हांक मारावी । माऊली जवळ यावी ॥ ५९२ ॥< br />
< br />
नामाची सोबत असता । हरीस पहाता तत्वता ।< br />
तेणे आनंदमय सर्वथा । आनंद आनंद म्हणता ॥ ५९३ ॥< br />
< br />
नामाची सोबत करता । आनंदमय जगता ।< br />
चिंता काळजी न वृथा । ईश्वराचा हेतू म्हणता ॥ ५९४ ॥< br />
< br />
नामाची असता जोड । भगवंताची जोड ।< br />
जितुकी नामात ओढ । तितुके नाम गोड ॥ ५९५ ॥< br />
< br />
नामाने नाम जोडता । भगवंतच जोडता ।< br />
भवदुःख तोडता । आनंद जोडता ॥ ५९६ ॥< br />
< br />
जोड असता नामाची । जोड भगवंताची ।< br />
जोड असता दोघांची । जोड आनंदाची ॥ ५९७ ॥< br />
< br />
नामाने नाम जोडता । नामपथ करता ।< br />
नामपथावर चालता । मुक्कामी पोहोचता ॥ ५९८ ॥< br />
< br />
नाम घ्यावे ओढीने । भगवंताच्या गोडीने ।< br />
नाम घेता गोडीने । भगवंत येतो ओढीने ॥ ५९९ ॥< br />
< br />
नामात असावी ओढ । तेणेच नाम गोड ।< br />
जितुकी नामात ओढ । तितुकी भगवंताची जोड ॥ ६०० ॥< br />
< br />
नाम घ्यावे सवडीने । भगवंताच्या ओढीने ।< br />
नामाच्याच गोडीने । भगवंताचे होते येणे ॥ ६०१ ॥< br />
< br />
भुले भगवंत नामाला । भुले नामाच्या गोडीला ।< br />
अधिकाधिक गोडीला । अधिक अधिक जोडीला ॥ ६०२ ॥< br />
< br />
नाम घ्यावे कर्तव्याने । कर्तव्याच्या जाणीवेने । < br />
मिळते सर्व जाणीवेने । जाते सर्व उणीवेने ॥ ६०३ ॥< br />
< br />
नाम घ्यावे आळवुन । कर्तव्य जाणीव ठेवुन ।< br />
नाम घेता आपणहुन । भगवंत येतो आपनहुन ॥ ६०४ ॥< br />
< br />
नाम आळवुन घेता । भगवंत येता जाता ।< br />
तोच ठरतो त्राता । संकट निवारता ॥ ६०५ ॥< br />
< br />
कर्तव्याने नाम घ्यावे । कर्तव्य चोख बजवावे ।< br />
नामाने मन पोसावे । अंतरात्म्या तोषवावे ॥ ६०६ ॥< br />
< br />
नामासाठी नाम घ्यावे । निश्चय ठाम असावे ।< br />
देणार्‍याने द्यावे । सर्व त्याचे समजावे ॥ ६०७ ॥< br />
< br />
काय आहे देहात ? । काय नाही नामात ? ।< br />
ह्याच सदा जाणीवेत । नाम यावे मुखात ॥ ६०८ ॥< br />
< br />
जितुके नामात प्रेम । तितुका नामाचा नेम ।< br />
तितुके भगवंताचे प्रेम । जितुके नामात प्रेम ॥ ६०९ ॥< br />
< br />
प्रेम करावे नामावर । तेणे प्रेम भगवंतावर ।< br />
जितुका नेम नामावर । तितुका भगवंतावर ॥ ६१० ॥< br />
< br />
नेम घरावा नामाचा । नेम धरावा भगवंताचा ।< br />
तेणे शिकार होण्याचा । योग भगवंताचा ॥ ६११ ॥< br />
< br />
जितुका नामाचा रोख । तितुका भगवंत चोख ।< br />
नामाचा नेम अचुक । भगवंत बिनचुक ॥ ६१२ ॥< br />
< br />
साधा साधा एकरूपता । नामात तुम्ही असता ।< br />
एकरूपता असता । आनंद स्वरूप पहाता ॥ ६१३ ॥< br />
< br />
नामात एकरूपता । तेणे काहुर न चित्ता ।< br />
सदा वसे प्रसन्नता । विरे उद्विग्नता ॥ ६१४ ॥< br />
< br />
नामात एकरूप होता । आनंदाचेच होता ।< br />
प्रारब्ध सहज भोगता । त्यास महत्व न देता ॥ ६१५ ॥< br />
< br />
नामात एकरूप होता । चिंता क्लेश विसरता ।< br />
नामात आनंद मिळता । आनंद वृत्तीने जगता ॥ ६१६ ॥< br />
< br />
नामाने मनास पोसता । देहास पोसता पोसता ।< br />
आत्मोन्नती करता । अधोगती टाळता ॥ ६१७ ॥< br />
< br />
नामाने होते आत्मोन्नती । तेणे आत्म्यास आनंद अती ।< br />
आनंद साठता चित्ती । भगवंताची प्रिती ॥ ६१८ ॥< br />
< br />
सदा नामाभोवती । तेणे शाश्वत सभोवती ।< br />
शाश्वतावर होते प्रिती । अशाश्वताची न भिती ॥ ६१९ ॥< br />
< br />
नामात साधता शाश्वत । तेणे टाळता अशाश्वत ।< br />
शाश्वतच खरे सत्य । अशाश्वत असत्य ॥ ६२० ॥< br />
< br />
नामात साधता सत्य । दूर लोटता असत्य ।< br />
भगवंता प्रिय सत्य । तेणे भेटतो नित्य ॥ ६२१ ॥< br />
< br />
येता जाता घेता नाम । सत्याचाच मुक्काम ।< br />
असत्यास लगाम । असत्यास रामराम ॥ ६२२ ॥< br />
< br />
नामात असता नित्य । दिसु लागते सत्य ।< br />
दूर पळते असत्य । असता नाम सातत्य ॥ ६२३ ॥ < br />
< br />
नामाच्या सातत्यात । सत्यच येते पुढ्यात ।< br />
सदा रमता सत्यात । भगवंत येतो पुढ्यात ॥ ६२४ ॥< br />
< br />
नामात जडते सत्य । नामच मुळात सत्य ।< br />
नामात असता नित्य । दूर लोटता अनित्य ॥ ६२५ ॥< br />
< br />
नामात आपण असावे । तेणे सत्यास पहावे । < br />
सत्यच जवळ करावे । असत्यास घालवावे ॥ ६२६ ॥< br />
< br />
नाम मुळात बोलके । तेणे करते बोलके ।< br />
अशाश्वताचे धोके । टाळण्या होते बोलके ॥ ६२७ ॥< br />
< br />
नाम मुळातच बोलके । कैसे होणार मुके ? ।< br />
नामास म्हणता मुके । तो आनंदास मुके ॥ ६२८ ॥< br />
< br />
नामाने बोलके व्हावे । भगवंताशी बोलावे ।< br />
ऐसे आपण बोलावे । भगवंताने बोलावे ॥ ६२९ ॥< br />
< br />
नामातला शब्द एकेक । लक्ष वेधतो एकेक ।< br />
नामात मिळते एक एक । नामातच मिळते अनेक ॥ ६३० ॥< br />
< br />
एकासाठी जे नाम । अनेकांसाठी ते नाम ।< br />
एकाचे घेता नाम । अनेक साधता नाम ॥ ६३१ ॥< br />
< br />
नामाचे बोलता बोल । नेमके बोलता बोल ।< br />
वायफळाचा न घोळ । सदा सावरता तोल ॥ ६३२ ॥< br />
< br />
नामात असता लक्ष । तेणे साधता लक्ष्य ।< br />
त्यासी होता सख्य । असख्याशी सख्य ॥ ६३३ ॥< br />
< br />
नामाशी होता सख्य । भगवंताशी सख्य ।< br />
तेणे सत्याशी सख्य । तेणे आनंदाशी सख्य ॥ ६३४ ॥< br />
< br />
नामाशी सख्य साधता । सर्वांशी सख्य साधता ।< br />
असख्य सदा टाळता । सख्याचे महत्व कळता ॥ ६३५ ॥< br />
< br />
नामाचे बोल बोलता । सख्याचे बोल बोलता ।< br />
सख्याशी सख्य होता । भगवंताशी सख्य करता ॥ ६३६ ॥< br />
< br />
नामात सख्य जडते । सख्याशी नाते जडते ।< br />
सख्याचे होण्याते । भगवंताचे होण्याते ॥ ६३७ ॥< br />
< br />
नामात सख्याचा भाव । असख्याचा अभाव ।< br />
असता नामाचा अभाव । असख्याचा भाव ॥ ६३८ ॥< br />
< br />
नामाशी सख्य करता । सख्य भावे जगता ।< br />
असख्य पार विसरता । सख्यात रममाण होता ॥ ६३९ ॥< br />
< br />
नामाशी सख्य करावे । तेणे शाश्वताचे व्हावे ।< br />
शाश्वतात रमावे । तेणे भगवंताचे व्हावे ॥ ६४० ॥< br />
< br />
नामाशी होता सख्य । सख्य असख्य दुर्लक्ष ।< br />
नामाकडे असता लक्ष । भगवंताकडे लक्ष ॥ ६४१ ॥< br />
< br />
नामात असता लक्ष । भगवंताचे वेधता लक्ष ।< br />
तेणे आनंदाशी सख्य । काळाचे न भक्ष्य ॥ ६४२ ॥< br />
< br />
नामात आंसु गाळता । दःखाश्रु टाळता ।< br />
नामात आंसु टाळता । दःखाश्रु गाळता ॥ ६४३ ॥< br />
< br />
नामात गाळता आंसवे । व्यवहारी हांसवे ।< br />
नामात टाळता आंसवे । व्यवहारी आंसवे ॥ ६४४ ॥< br />
< br />
नामात अश्रु गाळता । आनंदात भिजता ।< br />
नामात अश्रु टाळता । चिंता व्यथेत बुडता ॥ ६४५ ॥< br />
< br />
अश्रु गाळता नामात । तेणे आनंद नामात ।< br />
तेणे आनंद चित्तात । तेणे आनंद सर्वात ॥ ६४६ ॥< br />
< br />
नामातले अश्रु आनंदाचे । कधी न ते दुःखाचे ।< br />
अश्रु सरतात भेटीचे । पुनर्मिलनाच्या आनंदाचे ॥ ६४७ ॥< br />
< br />
नामात आंसवे हांसवे । वेळेवेळेने अनुभवावे ।< br />
कोंडलेले निघावे । तेणे मोकळे करावे ॥ ६४८ ॥< br />
< br />
नका कंटाळु नामाला । नाम येऊद्या मुखाला ।< br />
चिंता क्लेश दुःखाला । उपयुक्त विसरायला ॥ ६४९ ॥< br />
< br />
नाम घ्यावे येता जाता । कधी न ते कंटाळता ।< br />
ऐशी स्थिती होता । सुखदुःखे विसरता ॥ ६५० ॥< br />
< br />
न कंटाळता नामाला । सहज येता मुखाला ।< br />
नाम तारते प्रसंगाला । हेच येते अनुभवाला ॥ ६५१ ॥< br />
< br />
नको नामाचा कंटाळा । सदा टाळा कंटाळा ।< br />
नाम असता मुखाला । कंटाळा न वाट्याला ॥ ६५२ ॥< br />
< br />
नाम घेता न कंटाळता । कंटाळा नामाने टाळता ।< br />
तेणे उत्साह येता जाता । सदा वाट्याला प्रसन्नता ॥ ६५३ ॥< br />
< br />
नाम घेता येता जाता । तेणे कंटाळा टाळता ।< br />
तेणे प्रसन्नता चित्ता । तेणे आनंद चित्ता ॥ ६५४ ॥< br />
< br />
प्रारब्धातला एकेक क्षण । असतो विलक्षण ।< br />
नामात घालवता क्षण । न वाटे विलक्षण ॥ ६५५ ॥< br />
< br />
प्रारब्ध भोग ऐसे । तेच चित्त जाळतसे ।< br />
जो नामात रमतसे । सहज भोगतसे ॥ ६५६ ॥< br />
< br />
प्रारब्ध भोग विचित्र । कधी न स्पष्ट चित्र ।< br />
परी नामास करता मित्र । सर्वच होतात मित्र ॥ ६५७ ॥< br />
< br />
नामास मित्र समजा । तेणे भय न काळजा ।< br />
चिंता क्लेश होता वजा । तेणे आनंद मजा ॥ ६५८ ॥< br />
< br />
नामात गुंतुन राहाता । तेणे नाममय होता ।< br />
तेणे भयमुक्त होता । भयभीत न होता ॥ ६५९ ॥< br />
< br />
व्हावयाचे ते होऊ द्या । नामात जीव रमु द्या ॥< br />
प्रारब्ध भोगास येऊ द्या । तेच म्हणतील येऊ उद्या ॥ ६६० ॥< br />
< br />
आपण व्हावे नामाचे । कुणी पाहिले उद्याचे ? ।< br />
नको कारण चिंतेचे । विनाकारण भय त्याचे ॥ ६६१ ॥< br />
< br />
आज व्हावे नामाचे । उद्या व्हावे मोहमायेचे ।< br />
तेणे योग मोहमायेचे । न सतावण्याचे ॥ ६६२ ॥< br />
< br />
आज रमावे नामात । तेणे आज आनंदात ।< br />
तेणे काल नामात । उद्याही राहाल नामात ॥ ६६३ ॥< br />
< br />
आज नामात रमावे । आनंदास लुटावे ।< br />
आनंदात रमावे । ऐसे नित्याचेच व्हावे ॥ ६६४ ॥< br />
< br />
भजा भजा नाम आज । आनंद मिळेल आज ।< br />
तेणे शांती मिळेल आज । नामच राखेल लाज ॥ ६६५ ॥< br />
< br />
नामात घालवता आज । शांती समाधान आज ।< br />
नामाचा नेम करा आज । प्रसन्नता चित्ता आज ॥ ६६६ ॥< br />
< br />
नामास आधार मानावे । नाम मुखी असावे ।< br />
सुखदुःखात नाम घ्यावे । चिंता क्लेश टाळावे ॥ ६६७ ॥< br />
< br />
नामास आधार मानता । शांती प्राप्त करता ।< br />
प्रारब्ध सहज भोगता । उद्विग्न न होता ॥ ६६८ ॥< br />
< br />
आधार मानावे नामास । नाम असावे मुखास ।< br />
येता जाता त्याचा ध्यास । तेणे भगवंत सहवास ॥ ६६९ ॥< br />
< br />
नामास मानवे आधार । तेणे न कधी निराधार ।< br />
त्याच्यावर ठेवता भार । प्रपंचाचा न वाटे भार ॥ ६७० ॥< br />
< br />
नामास आधार मानण्यात । तरणोपाय त्यात ।< br />
भयभीत न चित्तात । कुठच्याही प्रसंगात ॥ ६७१ ॥< br />
< br />
नामास आधार माना । सुखदुःखे गौण माना ।< br />
शांती समाधान मना । जगु नये नामाविणा ॥ ६७२ ॥< br />
< br />
नाम जीवनी मुख्य माना । आनंदाची खान जाणा ।< br />
आनंदीत रहाण्या । जगु नये नामाविणा ॥ ६७३ ॥< br />
< br />
नामास मानता प्रमाण । सुखदुःखे समान ।< br />
उणीवेस न स्थान । प्रसन्नतेस स्थान ॥ ६७४ ॥< br />
< br />
नामास प्रमाण माना । तेणे आनंद मना ।< br />
प्रसन्नता मना । नाही आनंदाविणा ॥ ६७५ ॥< br />
< br />
प्रमाण माना नामास । तेणे आनंद अनुभवास ।< br />
जेथे आनंदाचा वास । तेथे भगवंत वास ॥ ६७६ ॥< br />
< br />
नामात सांठला आनंद । तेणे भजता मिळे आनंद ।< br />
सर्वात दिसे आनंद । तेणे आनंदी आनंद ॥ ६७७ ॥< br />
< br />
नाम येता मुखाला । आनंद येतो घराला ।< br />
त्याच्या पाहुणचाराला । नामच उपयुक्त त्याला ॥ ६७८ ॥< br />
< br />
कुणी कितीही छळु द्या । नाम मुखी असु द्या ।< br />
नामात जीव रमु द्या । तेणे छळाची न बाधा ॥ ६७९ ॥< br />
< br />
नाम घेता मुखाला । छळणारा होतो लुळा ।< br />
छळण्याचा येतो कंटाळा । पश्चाताप त्याला ॥ ६८० ॥< br />
< br />
मुखी असु द्या नाम । भगवंताचे नाम ।< br />
तेणे आनंदाचे नाम । तेणे आनंदाचे धाम ॥ ६८१ ॥< br />
< br />
नामा तुला आळवता । सुटतो विचारांचा गुंता ।< br />
तुझ्यावरच भार ठेवता । निश्चिंती अनुभवता ॥ ६८२ ॥< br />
< br />
नामा तुला आळवावे । चिंता क्लेश स्वये जावे ।< br />
स्वस्थता अनुभवावे । सहज सुलभ व्हावे ॥ ६८३ ॥< br />
< br />
विचारांचा होता गुंता । चिंताक्रांत होता ।< br />
नामात मन रमवता । सहज सुटतो गुंता ॥ ६८४ ॥< br />
< br />
नामस्मरण करावे । नामासच सदा भजावे ।< br />
नामावर सोपवावे । त्यातच हित मानावे ॥ ६८५ ॥< br />
< br />
नामात तुम्ही रमता । तेणे नामाचेच होता ।< br />
त्यावर भरंवसा ठेवता । नामच तारते येता जाता ॥ ६८६ ॥< br />
< br />
ऐसे नाम भजावे । नामात दंग व्हावे ।< br />
एकरूपतेने भजावे । आनंदाश्रुने न्हावे ॥ ६८७ ॥< br />
< br />
ऐसे नाम आळवावे । कंठ दाटून यावे ।< br />
अंतरात्म्याने बोलावे । तेच स्वये ऐकावे ॥ ६८८ ॥< br />
< br />
नामाचे बोल बोलता । ईश्वरास संबोधता ।< br />
ते बोल तेणे ऐकता । मदतरूप येता जाता ॥ ६८९ ॥< br />
< br />
आपणा आळवता नामास । तेणे आळवता भगवंतास ।< br />
चैन न पडे भगवंतास । स्वयेच येतो दर्शनास ॥ ६९० ॥< br />
< br />
नाम घ्यावे मुखाने । भगवंताच्या जाणीवेने ।< br />
नको नाम उणीवेने । परी भगवंताच्या गोडीने ॥ ६९१ ॥< br />
< br />
नामा ! आळवावे तुला । आनंद होतो मनाला ।< br />
आनंदाच्या अनुभवाला । नाम पुन्हा पुन्हा मुखाला ॥ ६९२ ॥< br />
< br />
आळवावे नामास । तेच उपयुक्त तरण्यास ।< br />
नको फाजील साधनास । सहज सोपे नामास ॥ ६९३ ॥< br />
< br />
ऐसे नाम आळवावे । भगवंताने खुष व्हावे ।< br />
तेणे स्वये दर्शन द्यावे । ऐसे जीवन अनुभवावे ॥ ६९४ ॥< br />
< br />
ऐसे नाम आळवावे । शुद्ध हेतु जागृत व्हावे ।< br />
शुद्ध सात्विक जगावे । तेणे भगवंताचे व्हावे ॥ ६९५ ॥< br />
< br />
आपण होता नामाचे । तेणे योग दर्शनाचे ।< br />
अनुभव आनंदाचे । शांती समाधानाचे ॥ ६९६ ॥< br />
< br />
नामास तुम्ही आळवता । अंतर्मन जागृत करता ।< br />
अंतर्मनाचे ऐकता । जीवनी सुसंगतता ॥ ६९७ ॥< br />
< br />
नाम आळवा आळवा । तेणे भगवंत आळवा ।< br />
चिंता क्लेश घालवा । आनंद अमृत अनुभवा ॥ ६९८ ॥< br />
< br />
ऐसे नाम आळवावे । भगवंतानेच धावावे ।< br />
भक्तांचे होऊन रहावे । मनोरथाचे सारथी व्हावे ॥ ६९९ ॥< br />
< br />
रंगुन जा रंगुन जा । नामात रंगुन जा ।< br />
तेणे श्रीहरी भजा । येता जाता नित्य भजा ॥ ७०० ॥< br />
< br />
रंगुन जावे रंगुन जावे । नामातच तल्लीन व्हावे ।< br />
आंसु ओघळावे । ऐसे नाम भजावे ॥ ७०१ ॥< br />
< br />
भजा भजा हरी भजा । येता जाता त्यास भजा ।< br />
तेणेच भेटे अवघा । करतो हलका बोजा ॥ ७०२ ॥< br />
< br />
हरी नाम भजावे हरी । तोच भवदुख्ह हरी ।< br />
येता जाता भजता हरी । दुःख न दाटे उरी ॥ ७०३ ॥< br />
< br />
मुखे हरी नाम भजा । तेणे भय न काळजा ।< br />
आनंद उरी बाळगा । हरी हरी म्हणत जा ॥ ७०४ ॥< br />
< br />
हरी नाम भजता हरी । हरीच येतो सत्वरी ।< br />
विविध रूपे स्वारी । खुण पटवणारी ॥ ७०५ ॥< br />
< br />
हरी हरी हरी हरी । मुखे येऊ दे हरी ।< br />
देहात आत्मा जोवरी । नाम राहु दे मुखावरी ॥ ७०६ ॥< br />
< br />
हरी हरी हरी हरी । तुझ्या नामात गोडी भारी ।< br />
येता जाता म्हणता हरी । मधुर बोल जिभेवरी ॥ ७०७ ॥< br />
< br />
हरी हरी हरी म्हणा । येता जाता हरी म्हणा ।< br />
प्रारब्ध भोग भोगण्या । नाही सहाय्य हरी विणा ॥ ७०८ ॥< br />
< br />
हरी हरी म्हणा हरी । सुख दुःखे म्हणा हरी ।< br />
सुखदुःखाची येरझारी । न वाटणार भारी ॥ ७०९ ॥< br />
< br />
हरी हरी हरी हरी । नामात आनंद भारी ।< br />
अहर्निष जपता हरी । तोच भवदुःख हरी ॥ ७१० ॥< br />
< br />
हरी हरी हरी हरी । नित्य नाम मुखावरी ।< br />
भाव राहु दे अंतरी । तेणे वदेन मी हरी ॥ ७११ ॥< br />
< br />
हरीस नित्य स्मरावे । हरी हरी वदावे ।< br />
हरीस कर्ता करावे । सारे तुझेच म्हणावे ॥ ७१२ ॥< br />
< br />
नित्य स्मरा हरी हरी । नामाच्या भरा घागरी ।< br />
त्या उपयुक्त संसारी । नको वृथा दारोदारी ॥ ७१३ ॥< br />
< br />
नित्य नाम घेता हरी । सदा नाम ओठावरी ।< br />
तोच देतो भाजी भाकरी । भाव असुद्या उरी ॥ ७१४ ॥< br />
< br />
नित्य नाम हरीचे घ्यावे । हरीस सदा स्मरावे ।< br />
अकर्ता भावे जगावे । ‘मी’ स पार विसरावे ॥ ७१५ ॥< br />
< br />
हरी हरी वदता हरी । डोळ्यासमोर दिसे हरी ।< br />
रूप सांठता उरी । आनंद होतो मना भारी ॥ ७१६ ॥< br />
< br />
वदा वदा हरी हरी । स्मरा प्रत्येक प्रहरी ।< br />
ध्यास लागता अंतरी । भेट होते सत्वरी ॥ ७१७ ॥< br />
< br />
हरी हरी वदावे । त्यावर सोपवावे ।< br />
येता जाता स्मरावे । हंसत मुखे जगावे ॥ ७१८ ॥< br />
< br />
हरी हरी वदा हरी । सदा वदा मुखे हरी ।< br />
लहा हरी चराचरी । हरी दिसेल सत्वरी ॥ ७१९ ॥< br />
< br />
नामे स्मरता हरी । नामात दिसे हरी ।< br />
येता जाता जो उच्चारी । तरेल भवसागरी ॥ ७२० ॥< br />
< br />
येता जाता हरी म्हणता । तेणे आनंद होतो मना ।< br />
चिंता काळजी न मना । आनंद वाटे जगताना ॥ ७२१ ॥< br />
< br />
हर घडीस भजता हरी । तेणे उद्धार संसारी ।< br />
नको चिंता वृथा उरी । तोच सारी दूर करी ॥ ७२२ ॥< br />
< br />
पळ पळ भजता हरी । तोच सोबती श्रीहरी ।< br />
ऐसा भाव च्ज्याच्या उरी । चिंता काळजी न उरी ॥ ७२३ ॥< br />
< br />
हरी हरी म्हणावे । तूच तार म्हणावे ।< br />
हरी स्मरणे जगावे । तेच हित मानावे ॥ ७२४ ॥< br />
< br />
हरी नाम ओठावरती । तेणे श्रीहरी सोबती ।< br />
जन्मोजन्मी गांठीभेटी । हरी हरी नाम महती ॥ ७२५ ॥< br />
< br />
हरी हरी भजताना । आनंद वाटतो मना ।< br />
आनंद वृत्तीने जगताना । शांती समाधान मना ॥ ७२६ ॥< br />
< br />
भजा भजा श्रीहरी । येता जाता श्रीहरी ।< br />
एकरूप होता श्रीहरी । विविध रूपे दावे हरी ॥ ७२७ ॥< br />
< br />
एकरूपे भजता हरी । विविध भाव अंतरी ।< br />
शुद्ध भाव जो अंतरी । जागृत होतो सत्वरी ॥ ७२८ ॥< br />
< br />
हरीनामाच्या तालावरी । लुब्ध होतो श्रीहरी ।< br />
संतोषता श्रीहरी । वर देतो सत्वरी ॥ ७२९ ॥< br />
< br />
आम्ही कोण कुणाचे ? । आम्ही श्रीहरीचे ।< br />
नाम घेता श्रीहरीचे । भय न काळजीचे ॥ ७३० ॥< br />
< br />
हरी नामाची साथ करा । भवसागरी तरा ।< br />
हरीस जवळ करा । जीव सार्थक करा ॥ ७३१ ॥< br />
< br />
हरी हरी भजता । बंधनमुक्त होता ।< br />
हरीस जवळ करता । तुम्ही ऋणमुक्त होता ॥ ७३२ ॥< br />
< br />
श्रीहरीस काय हवे ? । अंतरीचे शुद्ध भाव हवे ।< br />
जो स्मरे ऐशा भावे । हरीने जवळ करावे ॥ ७३३ ॥< br />
< br />
येता जाता भजता हरी । हरीच सोय करी ।< br />
कृपाप्रसाद त्यावरी । जो राहे हरी नामावरी ॥ ७३४ ॥ < br />
< br />
काय सांगु हरी महती ? । हरी साठवता चित्ती । < br />
मोहमाया सोबती । परी चित्ता न जाळती ॥ ७३५ ॥< br />
< br />
हरी हरी हरी भजा । येता जाता हरी भजा ।< br />
हरीची होता येजा । तेणे भय न काळजा ॥ ७३६ ॥< br />
< br />
हरी हरी भजावे । आत्म्यास संतोषावे ।< br />
हरीत चित्त गुंतवावे । हरीत एकरूप व्हावे ॥ ७३७ ॥< br />
< br />
मुखे हरी हरी म्हणावे । सदा हरीमुख पहावे ।< br />
हरीमुखे जे जे निघावे । ते शब्द झेलावे ॥ ७३८ ॥< br />
< br />
हरी बोल बोलावे । हरीस बोलका करावे ।< br />
हरीचे शब्द झेलावे । त्यातच हित मानावे ॥ ७३९ ॥< br />
< br />
ऐसे वदावे हरी हरी । मुग्ध व्हावे क्षणभरी ।< br />
हरी बोलावर भाळे हरी । जवळ येई सत्वरी ॥ ७४० ॥< br />
< br />
हरी हरी वदा सदा । येता जाता हरी सर्वदा ।< br />
हरी दिसावा एकदा । हाच ध्यास असुद्या ॥ ७४१ ॥< br />
< br />
येता जाता भजता हरी । देहाची शुद्धता भारी ।< br />
शुद्ध भाव ज्याचे अंतरी । सुकर्मे सदा आचरी ॥ ७४२ ॥< br />
< br />
हरी हरी वदा हरी । सदा मुखे भजा हरी ।< br />
आनंद मनास भारी । नयनाश्रु गालावरी ॥ ७४३ ॥< br />
< br />
मुखे भजता हरी हरी । हरीमय भाव अंतरी ।< br />
सर्वत्रास दिसे हरी । हरी दिसे चराचरी ॥ ७४४ ॥< br />
< br />
मुखे वदा सदा हरी । ध्यास असुद्या अंतरी ।< br />
हरी नामात गोडी भारी । चाखावी वरचेवरी ॥ ७४५ ॥< br />
< br />
मनाने व्हावे हरीचे । देहाने व्हावे प्रपंचाचे ।< br />
ऐसे कर्म होई ज्याचे । बोज न प्रपंचाचे ॥ ७४६ ॥< br />
< br />
ज्याच्या मुखे हरी हरी । अमृतकुंभ त्याचे घरी ।< br />
सेवता वरचेवरी । जीवास आनंद भारी ॥ ७४७ ॥< br />
< br />
हरी नामाचा सूर । काळजीस करे दूर ।< br />
चित्तातली हुरहुर । पळुन जाते दूर ॥ ७४८ ॥< br />
< br />
हरीनामाच्या सुरात । हरी श्वासोच्छवासात । < br />
ऐशा तर्‍हे जगण्यात । जीवास उद्धरतात ॥ ७४९ ॥< br />
< br />
अहर्निश हरी भजता । हरीच ठरतो त्राता ।< br />
हरीस शरण जाता । हरीचे आपण होता ॥ ७५० ॥< br />
< br />
येता जाता भजता हरी । कर्ता करविता होतो हरी ।< br />
हरीचे उष्टे ज्याचे घरी । तो जीव धन्य संसारी ॥ ७५१ ॥< br />
< br />
हरी हरी भजा हरी । हरी तिमिर नाश करी ।< br />
तेणे प्रकाश सत्वरी । सारी खूबी हरी करी ॥ ७५२ ॥< br />
< br />
हरी हरी हरी भजता । ज्ञानोदय अनुभवता ।< br />
तेणे प्रसन्नता चित्ता । तेणे हरीमयच होता ॥ ७५३ ॥< br />
< br />
जो जो झाला हरीमय । तो तो तरला भव ।< br />
साधुसंत अनुभव । आपण व्हावे हरीमय ॥ ७५४ ॥< br />
< br />
हरीमय होता जीवनी । न मुद्दाम जावे लागे वनी ।< br />
सुखदुःखे अनुभवुनी । चित्ता प्रसन्न ठेवुनी ॥ ७५५ ॥< br />
< br />
मुळात हरी लोचट । स्वस्वभावे शोधे भक्त ।< br />
जो जो हरी नामात । लोचट येतो दारात ॥ ७५६ ॥< br />
< br />
विठ्ठल विठ्ठल  म्हणावे । विठ्ठलात रंगुन जावे ।< br />
नामात विठ्ठल  पहावे । सर्वात विठ्ठल  पहावे ॥ ७५७ ॥< br />
< br />
नाम घ्यावे विठ्ठलाचे । तेणे हित प्रपंचाचे ।< br />
नामाने व्हा विठ्ठलाचे । सारे समजा विठ्ठलाचे ॥ ७५८ ॥< br />
< br />
विठ्ठल विठ्ठल म्हणा । शांती समाधान मना ।< br />
आनंद मुखे म्हणा । येता जाता विठ्ठल म्हणा ॥ ७५९ ॥< br />
< br />
विठ्ठल विठ्ठल बोला । ओळखाल मायेला ।< br />
विठ्ठल ज्याच्या मुखाला । माया न सतावे त्याला ॥ ७६० ॥< br />
< br />
विठ्ठल विठ्ठल म्हणावे । त्याचे नाद घुमवावे ।< br />
दुसर्‍यासही रंगवावे । त्यासही आनंद द्यावे ॥ ७६१ ॥< br />
< br />
विठ्ठलाच्या नादात । रहाल तुम्ही आनंदात ।< br />
चिंता भय न चित्तात । विठ्ठलच चित्तात ॥ ७६२ ॥< br />
< br />
विठ्ठल च्याच्या मुखी । त्याचा प्रपंच सुखी ।< br />
सदा राहे हंसतमुखी । सुखदुःखे सम लेखी ॥ ७६३ ॥< br />
< br />
विठ्ठल विठ्ठल भजावा । त्यात जीव रमवावा ।< br />
ऐसा विठ्ठल भजावा । विषयाचा वीट यावा ॥ ७६४ ॥< br />
< br />
विषयाचा येता वीट । विठ्ठलासी देता विट ।< br />
सोडे पंढरीची वाट । भक्ताची धरे वाट ॥ ७६५ ॥< br />
< br />
येता जाता विठ्ठल बोला । नयनाश्रु ओघळा ।< br />
माझा विठ्ठल भोळा । रखुमाईसह येतो वेळोवेळा ॥ ७६६ ॥< br />
< br />
रमा रमa विठ्ठलात । विठ्ठलाच्या जयघोषात ।< br />
विठ्ठल तोषतो नामात । तारतो वेळप्रसंगात ॥ ७६७ ॥< br />
< br />
पंढरपुरी नाही विठ्ठल । विठ्ठल पहावा सकळ ।< br />
कर्तव्य कर्मात विठ्ठल । अकर्ताभावात विठ्ठल ॥ ७६८ ॥< br />
< br />
विठ्ठलाचे नाम घ्यावे । विषयास घालवावे ।< br />
विठ्ठलातच रमावे । तेणे विषय विसरावे ॥ ७६९ ॥< br />
< br />
विठ्ठल खरा शाश्वत । अजुन भेटे नामात ।< br />
विषय अशाश्वत । व्यथा काळजात ॥ ७७० ॥< br />
< br />
सुख नाही विषयात । नको नको विषय चित्तात ।< br />
आनंद विठ्ठलात । साठवावा चित्तात ॥ ७७१ ॥< br />
< br />
विषयाचे दुःख पदरी । चिंता काळजी उरी ।< br />
विठ्ठल ज्याच्या मुखावरी । मनोव्यथा जाते दूरी ॥ ७७२ ॥< br />
< br />
होता विठ्ठलाचा गजर । विठ्ठल रखुमाई हजर ।< br />
भक्ताच्या हांकेवर । सोडती पंढरपुर ॥ ७७३ ॥< br />
< br />
विठ्ठल ज्याच्या मुखावर । त्याचे घर पंढरपुर ।< br />
चिंता काळजी पळे दूर । नाही चित्ती हुरहुर ॥ ७७४ ॥< br />
< br />
मुखे म्हणा विठ्ठल । निश्चय असावा अटळ ।< br />
त्यासी भजता पळपळ । पळा पळा आनंद सकळ ॥ ७७५ ॥< br />
< br />
विठ्ठलात रंगुन जा । येता जाता विठ्ठल भजा ।< br />
सर्व स्थळी त्याला भजा । सारे विठ्ठलाचे समजा ॥ ७७६ ॥< br />
< br />
विठ्ठलाचा होता ध्यास । त्याचा घडे सहवास ।< br />
भक्ताचा होता दास । पहातो प्रपंचास ॥ ७७७ ॥< br />
< br />
विठ्ठलाचा ध्यास बाळगा । येता जाता त्यास भजा ।< br />
तोच अन्नदाता समजा । निष्ठेने विठ्ठल भजा ॥ ७७८ ॥< br />
< br />
निश्चये भजता विठ्ठल । तेणे वाटचाल सरळ ।< br />
सुकर्मांचे वाढता बळ । चाखाल मधुर फळ ॥ ७७९ ॥< br />
< br />
विठ्ठलात गोडी भारी । कळे भजल्यावरी ।< br />
ऐसी गूडी न्यारी । नाही कुठे हो संसारी ॥ ७८० ॥< br />
< br />
माझा विठ्ठल भोळा । कनवाळु कृपाळा । < br />
भजता विठ्ठलाला । तेणे आनंद मनाला ॥ ७८१ ॥< br />
< br />
भोळा माझा विठ्ठल । नामात कळे सकळ ।< br />
निश्चय होता अटळ । सदा दिसे विठ्ठल ॥ ७८२ ॥< br />
< br />
नको नुसता उपवास । नामाचा हवा सहवास ।< br />
नामाचा असता ध्यास । तेने भगवंत सहवास ॥ ७८३ ॥< br />
< br />
विठ्ठलाचा करा गजर । भजा प्रहर नि प्रहर ।< br />
तेणे चिंतेचा विसर । नामात रमवता प्रहर ॥ ७८४ ॥< br />
< br />
विठ्ठलाचा करावा नाद । तेणे भेटे निर्विवाद ।< br />
क्षणा क्षणा आनंद । मिळतो निर्विवाद ॥ ७८५ ॥< br />
< br />
विठ्ठलात आनंद । नामात होता धुंद ।< br />
होता आनंदी आनंद । जगण्यात आनंद ॥ ७८६ ॥< br />
< br />
नाम आळवा नाम । भगवंताचे नाम ।< br />
येता जाता घेता नाम । पैलतीरी मुक्काम ॥ ७८७ ॥< br />
< br />
नाम घ्यावे भगवंताचे । तेणे त्याचे व्हावयाचे ।< br />
प्रपंचात रमायचे । त्याचा प्रपंच समजायचे ॥ ७८८ ॥< br />
< br />
भगवंतास आळवा । नामात वेळ घालवा ।< br />
तेणे जीव तोषवा । तेणे परमात्मा तोषवा ॥ ७८९ ॥< br />
< br />
भगवंताच्या नामात । खरा आनंद त्यात ।< br />
नामाने भजण्यात । आनंद वृत्तीने जगण्यात ॥ ७९० ॥< br />
< br />
भगवंताचे नाम । शांती समाधानाचे नाम ।< br />
जगण्यात खरा राम । मुखी असता नाम ॥ ७९१ ॥< br />
< br />
नाम न फुकट जाई । नामानेच खात्री होई ।< br />
जो नाम निष्ठेने घेई । भगवंत धाव घेई ॥ ७९२ ॥< br />
< br />
नामाचे बोल बोला । तेणे वृत्ती संभाळा ।< br />
नाम तारे प्रसंगाला । तेणे नाम मुखाला ॥ ७९३ ॥< br />
< br />
बोला बोला नाम बोला । तेणे आनंद मनाला ।< br />
येता जाता नाम बोला । तेणे शांती मनाला ॥ ७९४ ॥< br />
< br />
नाम बोला नाम । भगवंताचे नाम ।< br />
तेणे आनंदाचे धाम । समाधान मुक्काम ॥ ७९५ ॥< br />
< br />
नामाच्या निश्चयात । सातत्य कृत्यात ।< br />
यशाच्या दालनात । आपण प्रवेशतात ॥ ७९६ ॥< br />
< br />
नामाचा करा निश्चय । नाम भजा अक्षय ।< br />
तेणे पुण्य संचय । पापाचा होतो क्षय ॥ ७९७ ॥< br />
< br />
नामाच्या निश्चयात । नाम येते मुखात ।< br />
तेणे पुण्य फळात । सत्कर्मे आचरणात ॥ ७९८ ॥< br />
< br />
नामाचा निश्चय करा । नाम मार्ग सोपा बरा ।< br />
प्रपंचाचा पसारा । न वाटे बोजवारा ॥ ७९९ ॥< br />
< br />
निश्चय करा नामाच । तेणे प्रपंच सुखाचा ।< br />
येता प्रसंग दुःखाचा । आधार वाटे नामाचा ॥ ८०० ॥< br />
< br />
नामाचा आधार मोठा । नाही संत बोल खोटा ।< br />
नाही आनंदा तोटा । नामात लाभ मोठा ॥ ८०१ ॥< br />
< br />
जो जो रहातो नामात । तो तो रहातो आनंदात ।< br />
डोलतो आनंदात । नाम येता मुखात ॥ ८०२ ॥< br />
< br />
नाम सर्वदा साधक । नाही कधी ते बाधक ।< br />
प्रपंचास तारक । सदा आनंद दायक ॥ ८०३ ॥< br />
< br />
नामात आनंद मोठा । घ्यावा येता जाता ।< br />
प्रपंची नामच त्राता । कळे नाम भजता ॥ ८०४ ॥< br />
< br />
राहुन प्रपंचात । रहाता नामात ।< br />
नाम न आड त्यात । हेच कळे नामात ॥ ८०५ ॥< br />
< br />
नाम माझा सखा । तोच पाठीराखा ।< br />
नामाचे बोल ऐका । तरा जीवन नौका ॥ ८०६ ॥< br />
< br />
जीवन नौकेत । नाम वल्हे उपयुक्त ।< br />
खळखळत्या पाण्यात । नामाची साथ ॥ ८०७ ॥< br />
< br />
नामाची वल्हे घेता । पैलरीर गाठता < br />
भोवर्‍यात न गुंतता । नामानेच पुढे जाता ॥ ८०८ ॥< br />
< br />
संसाराच्या सागरात । प्रचंड खळखळाट ।< br />
नाम येता मुखात । भयभीती न चित्तात ॥ ८०९ ॥< br />
< br />
नामाच्या जोरावर । तरता भवसागर ।< br />
गाठता पैलतीर । नाम येता मुखावर ॥ ८१० ॥< br />
< br />
नाम बोलता अक्षय । पळुन जातो विषय ।< br />
तेणे होता निर्भय । तेने आनंदमय ॥ ८११ ॥< br />
< br />
नाही आनंद विषयात । ठासुन भरला तो नामात ।< br />
संत बोल ऐकण्यात । हित समजा त्यात ॥ ८१२ ॥< br />
< br />
नामाचा घ्यावा अनुभव । नामात होता निर्भय ।< br />
होता तुम्ही नाममय । सहज तरता भव ॥ ८१३ ॥< br />
< br />
नामाच्या अनुभवात । शहाणे व्यवहारात ।< br />
नाम नसता मुखात । मूर्खताच पदरात ॥ ८१४ ॥< br />
< br />
नामाची असता साथ । प्रसंगावर मात ।< br />
शांती समाधाने जगण्यात । निर्विवादे नामात ॥ ८१५ ॥< br />
< br />
साथ असता नामाची । भिती न भयाची ।< br />
पुढच्या वाटचालीची । हिम्मत व्हावयाची ॥ ८१६ ॥< br />
< br />
संतांचे बोल ऐकावे । नामातच रमावे ।< br />
तेणे आनंदी व्हावे । अनुभव घ्यावे ॥ ८१७ ॥< br />
< br />
संतबोल एकेक । नामाचे बोल कित्येक ।< br />
अनुभव एकेक । संत सांगती कित्येक ॥ ८१८ ॥< br />
< br />
संत नामाने तरले । अनुभव जमा झाले ।< br />
नामातच हित भले । अनुभव घेणे भले ॥ ८१९ ॥< br />
< br />
संतांचा बोल खराखुरा । नामच त्यांस आसरा ।< br />
नामात दिवाळी दसरा । दिसे आपल्या घरा ॥ ८२० ॥< br />
< br />
खरा खुरा आनंद । नामात निर्विवाद ।< br />
नको फुकट वाद । नामाचा घुमवा  नाद ॥ ८२१ ॥< br />
< br />
फुकटच्या वादात । शांती गमावतात । < br />
राहाता नामस्मरणात । शांती मिळवतात ॥ ८२२ ॥< br />
< br />
नामाचे आदेश पाळा । मनाचे संशय टाळा ।< br />
महत्व द्यावे नामाला । नको महत्व मनाला ॥ ८२३ ॥< br />
< br />
नामावर अवलंवावे । शंकेस स्थान नसावे ।< br />
नाम श्रद्धेने भजावे । श्रद्धायुक्त जगावे ॥ ८२४ ॥< br />
< br />
श्रद्धायुक्त नामाला । आनंद वाटे मनाला ।< br />
आनंद तोषायला । नाम येऊद्या मुखाला ॥ ८२५ ॥< br />
< br />
श्रद्धेचे महतव फार । त्यात नामाचे सार ।< br />
जो श्रद्धेने भजणार । आनंदीच रहाणार ॥ ८२६ ॥< br />
< br />
नामावर श्रद्धा ठेवता । निश्चिंतपणे जगता ।< br />
चिंता नसता चित्ता । उद्विग्नता न चित्ता ॥ ८२७ ॥< br />
< br />
श्रद्धा ठेवा नामावर । संत बोलले आजवर ।< br />
जे जे राहिले श्रद्धेवर । तरले भवसागर ॥ ८२८ ॥< br />
< br />
श्रद्धेने नाम भजता । श्रद्धेने भव तरता ।< br />
अश्रद्धेने जगता । चिंतायुक्त जगता ॥ ८२९ ॥< br />
< br />
नाम येता जाता घेता । प्रेरणा प्राप्त करता ।< br />
पडताळुन पहाता । श्रद्धेनेच जगता ॥ ८३० ॥< br />
< br />
नाम ज्याच्या मुखाला । श्रद्धेचे फळ त्याला ।< br />
सुसह्यपणे जगण्याला । मनःशांती मनाला ॥ ८३१ ॥< br />
< br />
नामात जे जे मिळते । ते ते श्रद्धेचे असते ।< br />
श्रद्धेला महत्व देण्याते । जीवन सफल होते ॥ ८३२ ॥< br />
< br />
नामातल्या ज्या प्रेरणा । त्या त्या आनंद देण्या ।< br />
मनःशांती मिळण्या । नाही नाम श्रद्धेविणा ॥ ८३३ ॥< br />
< br />
नाम श्रद्धेने भजा भजा । अश्रधा सदा त्यजा ।< br />
श्रद्धायुक्त जगत जा । अनुभव मिळवत जा ॥ ८३४ ॥< br />
< br />
नाम घ्यावे भगवंताचे । कर्तव्य समजायचे ।< br />
देहाचे ऋण फेडायचे । जाणीवेत रहायचे ॥ ८३५ ॥< br />
< br />
जन्म लाभला नामासाठी । जन कल्याणासाठी ।< br />
जन्म परोपकारासाठी । जन्म परमार्थासाठी ॥ ८३६ ॥< br />
< br />
नामात तुम्ही असता । परमार्थात असता ।< br />
प्रपंचात जरी राहाता । परी नाम मुखे भजता ॥ ८३७ ॥< br />
< br />
नको उसना संन्यास । नाम येऊ द्या मुखास ।< br />
राहुनी प्रपंचास । सहज भजता नामास ॥ ८३८ ॥< br />
< br />
नाम मुखी असता । प्रपंच त्याचा म्हणता ।< br />
प्रपंचात होऊन राहाता । अकर्ताभावे जगता ॥ ८३९ ॥< br />
< br />
नाम ज्याच्या मुखात । प्रपंच न बाधक ।< br />
न तो पीडादायक । सदा सुसह्यकारक ॥ ८४० ॥< br />
< br />
जमा उधार नामातले । वेगळे व्यवहारातले ।< br />
उसने जरी घेतलेले । तापदायक नसलेले ॥ ८४१ ॥< br />
< br />
नामातले वैभव आगळे । कळे जे नामामुळे ।< br />
खरेखुरे शाश्वतातले । अशाश्वत त्यजलेले ॥ ८४२ ॥< br />
< br />
शाश्वताची गोडी वेगळी । नामाने सोय केली ।< br />
नामात जी जी रमली । शाश्वतमय झाली ॥ ८४३ ॥< br />
< br />
नामच मुळात शाश्वत । कैसे होईल अशाश्वत ? ।< br />
तेणे नाम भजण्यात । शाश्वतच पुढ्यात ॥ ८४४ ॥< br />
< br />
नाम मुखे भजता । शाश्वतच भजता ।< br />
वेगळे काही न करता । सहजभावे जगता ॥ ८४५ ॥< br />
< br />
आपण व्हावे नामाचे । तेणे व्हाल शाश्वताचे ।< br />
जे जे झाले नामाचे । अनुभव शाश्वताचे ॥ ८४६ ॥< br />
< br />
आपण नाम भजावे । तेणे शाश्वत दिसावे ।< br />
ऐसे नाम भजावे । शाश्वतच पुढी यावे ॥ ८४७ ॥< br />
< br />
नुसते नाम भजण्यात । शाश्वते जगण्यात ।< br />
नुसत्याच चिंतनात । काय येणार पुढ्यात ? ॥ ८४८ ॥< br />
< br />
नाम भजण्यात सोपे । विना खटाटोपे ।< br />
जो नामा प्रपंच सोपे । न तापे प्रपंच तापे ॥ ८४९ ॥< br />
< br />
केव्हाही करा नामस्मरण । न त्यास कसले बंधन ।< br />
येता जाता नामस्मरण । येता जाता संभाषण ॥ ८५० ॥< br />
< br />
नाम उपयुक्त सर्वांस । बाल, स्त्री, पुरुषांस ।< br />
नाम न वगळे कुणास । जवळ करे सर्वांस ॥ ८५१ ॥< br />
< br />
नामातली उपयुक्तता । कळे नामयुक्त असता ।< br />
अनुसंधानात असता । उपयुक्तता टिकवता ॥ ८५२ ॥< br />
< br />
हरी नामात आहे गोडी । भजता भजता हरी जोडी ।< br />
नाम भजता हरघडी । हरी मुक्काम हरघडी ॥ ८५३ ॥< br />
< br />
हरी हरी भजावे । हरीस नित्य भजावे ।< br />
येता जाता भजावे ।हरी हरी म्हणावे ॥ ८५४ ॥< br />
< br />
हरी हरी नित्य प्रहरी । नाम येऊ द्या मुखावरी ।< br />
अवमंबता हरी वरी । सदा संतोष अंतरी ॥ ८५५ ॥< br />
< br />
हरी हरी नित्य म्हणावे । सारे हरीचेच म्हणावे ।< br />
हरीस कर्ता करावे । स्वस्थ चित्त अनुभवावे ॥ ८५६ ॥< br />
< br />
हरीनामाचा अनुभव । संत तरले भव ।< br />
संतांचे घेण्या अनुभव । आपण व्हावे हरीमय ॥ ८५७ ॥< br />
< br />
हरी हरी हरी बोला । मुखे हरी हरी बोला ।< br />
एक एक शब्द तोला । नंतरच तो बोला ॥ ८५८ ॥< br />
< br />
हरी हरी नित्य प्रहरी । तेणे हरी नित्य प्रहरी ।< br />
येता जाता वदता हरी । हरीच वसतो घरी ॥ ८५९ ॥< br />
< br />
हरीच राहुद्या उरी । तेणे चिंता न राहे उरी ।< br />
हरी हरी मुखावरी । तेणे आनंद साठे उरी ॥ ८६० ॥< br />
< br />
हरी हरी म्हणत जा । हरीस नित्य पहात जा ।< br />
हरी रूपे आठवत जा । त्याचा आनंद लुटत जा ॥ ८६१ ॥< br />
< br />
हरी नामात जो आनंद । कळे त्यात होता धुंद ।< br />
इतुका न कोठे आनंद । संत सांगे निर्विवाद ॥ ८६२ ॥< br />
< br />
हरी नामाची गोडी न्यारी । प्रत्येक प्रहरी वाढणारी ।< br />
गोडी जी जी चाखणारी । धन्य धन्य ती संसारी ॥ ८६३ ॥< br />
< br />
गोडी भारी न्यारी न्यारी । वदता सदा हरी हरी ।< br />
हरी सदा भजल्यावरी । गोडी हरी बरोबरी ॥ ८६४ ॥< br />
< br />
नाम भजा नित्य नित्य । संत बोलात खरा अर्थ ।< br />
हरी नामात आहे तथ्य । त्रिकालबाधित सत्य ॥ ८६५ ॥< br />
< br />
अविरत भजता हरी । सर्व त्याचे म्हटल्यावरी ।< br />
चिंता काळजी न उरी । हरीच सदा वसे उरी ॥ ८६६ ॥< br />
< br />
हरी नाम मुखावरी । येता जात नित्य प्रहरी ।< br />
हरीच वसतो उरी । कैसी चिंता राहे उरी ? ॥ ८६७ ॥< br />
< br />
हरी हरी वदा सदा । वदा वदा हरी सर्वदा ।< br />
हरीस पहाता एकदा । हरीच दिसे सर्वदा ॥ ८६८ ॥< br />
< br />
हरी नाम वदता वदता । प्रसन्नता अनुभवता ।< br />
स्वस्थ चित्ते जगता । हंसतमुखे जगता ॥ ८६९ ॥< br />
< br />
हरीनाम वदताना । आनंद सदा जगताना ।< br />
हरीस आळवताना । आनंदाश्रु नयनांना ॥ ८७० ॥< br />
< br />
हरीस आळवा केव्हाही । कुठच्याही प्रसंगीही ।< br />
हरीच उभा केव्हाही । रक्षण्या धाव घेई ॥ ८७१ ॥< br />
< br />
हरीस आळवा हरीस । आळवा तुम्ही हर घडीस ।< br />
हरी नामात परीस । सुवर्णच हरघडीस ॥ ८७२ ॥< br />
< br />
हरी हरी मुखे बोला । ऐकु येऊ द्या त्याला ।< br />
भक्ताच्या हांकेला । धावुन येई रक्षणाला ॥ ८७३ ॥< br />
< br />
हरीभक्ती सर्वांस । हरी न वगळे कुणास ।< br />
जो भजे हरी नामास । हरीच दिसे सर्वत्रांस ॥ ८७४ ॥< br />
< br />
येता जाता भजता हरी । सकळांत दिसे हरी ।< br />
नाही भेद अंतरी । हरीच भेद दूर करी ॥ ८७५ ॥< br />
< br />
हरी नाही हो एकेरी । कळे हरी भजल्यावरी ।< br />
एकास भजल्यावरी । दोघे भेटे सत्वरी ॥ ८७६ ॥< br />
< br />
हरीस प्रिय सकळ । सर्वांस करे जवळ ।< br />
हरीत दिसते सकळ । तेणे हरीनाम अटळ ॥ ८७७ ॥< br />
< br />
हरी हरी म्हणा हरी । तेणे आनंद मना भारी ।< br />
हरी नाम भजल्यावरी । आनंदाच्या राशी घरी ॥ ८७८ ॥< br />
< br />
हरी हरी भजता । हरी जवळ असता ।< br />
हरीस सदा पहाता । आनंद अनुभवता ॥ ८७९ ॥< br />
< br />
हरी हरी बोलता । येता जाता हरी बोलता ।< br />
अंतर्मुखे हरी पहाता । बहिर्मुखे वावरता ॥ ८८० ॥< br />
< br />
हरी हरी बोलावे । हरीसच बोलवावे ।< br />
भोवताल विसरावे । हरीमयच व्हावे ॥ ८८१ ॥< br />
< br />
हरीमय होता होता । भोवताल विसरता ।< br />
हरीनामात धुंद होता । वेगळा आनंद अनुभवता ॥ ८८२ ॥< br />
< br />
नामास करा जवळ । तेणेच ज्ञान सकळ ।< br />
मोहमाया मृगजळ । नाही लागणार झळ ॥ ८८३ ॥< br />
< br />
नामास जवळ करा । नामाचा खरा आसरा ।< br />
तोच मार्ग सदा बरा । भगवंता जवळ करा ॥ ८८४ ॥< br />
< br />
नामास करता जवळ । तेणे नामाचे सुफळ ।< br />
अशांतीचा पळ । शांतीचा सुकाळ ॥ ८८५ ॥< br />
< br />
नाम घ्या हो नाम । येता जाता भजा नाम ।< br />
सहज सोपे नाम । नका मोजु दाम ॥ ८८६ ॥< br />
< br />
नामात विचार सात्विक । तेणे कर्मे सात्विक ।< br />
सुफळे सात्विक । आनंद सात्विक ॥ ८८७ ॥< br />
< br />
नामात सत्वगुण । येता जाता करा मंथन ।< br />
तेने होता आचरण । तेणे सदा सदाचरण ॥ ८८८ ॥< br />
< br />
नामात पहाता रूप । भगवंताचे स्वरूप ।< br />
त्याचेशी होता एकरूप । पहाता आनंदरूप ॥ ८८९ ॥< br />
< br />
नामात रूप दिसते । तन्मय व्हावे लागते ।< br />
तन्मयतेने मिळते । नामाने साध्य होते ॥ ८९० ॥< br />
< br />
नामात होता तन्मय । होता आनंदमय ।< br />
चिंता क्लेश भय । त्याचा होतो क्षय ॥ ८९१ ॥< br />
< br />
नाम भजता अक्षय । आनंद मिळे अक्षय ।< br />
उद्विग्नतेचा क्षय । चित्त शांतीची सोय ॥ ८९२ ॥< br />
< br />
नाम अक्षय भजावे । प्रेरणामय व्हावे ।< br />
पडताळुन पहावे । दृढनिश्चयी व्हावे ॥ ८९३ ॥< br />
< br />
नाम भजावे आपणासाठी । मनःशांतीसाठी ।< br />
स्वार्थ परमार्थासाठी । जीवोद्धारासाठी ॥ ८९४ ॥< br />
< br />
देह झिजवा नामासाठी । नाम उपयुक्त देहासाठी ।< br />
जन्मोजन्मीचा साथी । नामाशिवाय कोण जगती ? ॥ ८९५ ॥< br />
< br />
जीवोद्धार नामात । तेणी रहावे नामात ।< br />
संत बोल उपयुक्त । अनुभवता नामात ॥ ८९६ ॥< br />
< br />
नाम घ्यावे कुणासाठी ? । आपल्या जीवासाठी ।< br />
आनंद देण्यासाठी । मनःशांतीसाठी ॥ ८९७ ॥< br />
< br />
नाम घ्यावे कर्तव्याने । देहाच्या जाणीवेने ।< br />
नाम आळवा मनाने । प्रसन्न व्हावे त्याने ॥ ८९८ ॥< br />
< br />
नामात होता रममाण । आनंदी होता आपण ।< br />
अनुभवता ऐसे क्षण । नित्य करता नामस्मरण ॥ ८९९ ॥< br />
< br />
संकल्प करा नामाचा । संकल्प करा आनंदाचा ।< br />
प्रारब्ध भोग भोगण्याचा । नाही त्रास जाणवायचा ॥ ९०० ॥< br />
< br />
नाम भजा अहर्निश । नामाचा करा जयघोष ।< br />
नामात दोषांचा र्‍हास । गुणांचाच सहवास ॥ ९०१ ॥< br />
< br />
नामाचा करता जयघोष । सद्‌गुणांची रास ।< br />
निर्गुण सगुणास । विविध रूपास ॥ ९०२ ॥< br />
< br />
नामात रूपे विविध । तेणे बोध विविध ।< br />
नेमका काय बोध । नामच करे बोध ॥ ९०३ ॥< br />
< br />
नामस्मरणे बोध होतो । तोच मार्ग दावतो ।< br />
जो मार्ग अवलंबतो । तो भवसागर तरतो ॥ ९०४ ॥< br />
< br />
नामात बोध होता । स्वस्थता अनुभवता ।< br />
नामाचे आदेश पाळता । सहजपणे जगता ॥ ९०५ ॥< br />
< br />
नामात बोध कशाचा ? । नामात बोध शाश्वताचा ।< br />
ऐसा मार्ग आचरण्याचा । हितावह ठरायचा ॥ ९०६ ॥< br />
< br />
नामाने शाश्वत कळते । अशाश्वत पळते ।< br />
शाश्वतात मन रमते । जीवाचे सार्थक होते ॥ ९०७ ॥< br />
< br />
श्रद्धा ठेवता नामावर । श्रद्धा भगवंतावर ।< br />
श्रद्धा ठेवता शाश्वतावर । जाता पैलतीरावर ॥ ९०८ ॥< br />
< br />
नामाचे शब्द रोकडे । नाही कधी मागेपुढे ।< br />
योग्य वेळेस योग्य पुढे । तेणेच उकले कोडे ॥ ९०९ ॥< br />
< br />
नामात दडले सत्य । जीवास उपयुक्त ।< br />
जितुके तुम्ही नामात । तितुके तुम्ही सत्यात ॥ ९१० ॥< br />
< br />
नका शोधु सत्य ।नाम भजा नित्य ।< br />
नामात दडलेले सत्य । कळते भजता नाम नित्य ॥ ९११ ॥< br />
< br />
नामास करता जवळ । कळे सत्य सकळ ।< br />
सत्यास करता जवळ । असत्याची न वाटचाल ॥ ९१२ ॥< br />
< br />
नामात नित्य रमावे । तेच हित मानावे ।< br />
नामावर सोपवावे । त्याच्या आदेशे जगावे ॥ ९१३ ॥< br />
< br />
नामात नित्य रमता । आत्म्यास नित्य तोषता ।< br />
परमात्म्यास तोषता । जरी प्रपंच करता ॥ ९१४ ॥< br />
< br />
प्रपंची नाम त्राता । तेणे नाम भजता ।< br />
गाफिल न रहाता । प्रपंच करता ॥ ९१५ ॥< br />
< br />
परमार्थाची साधने । नाम, भजन, कीर्तने ।< br />
रमता एकनिष्ठेने । तरता भव खात्रीने ॥ ९१६ ॥< br />
< br />
परमार्थाच्या साधनात । नाम सहज सोपे त्यात ।< br />
कुठच्याही प्रसंगात । नाही अवडंबर त्यात ॥ ९१७ ॥< br />
< br />
सहज सोपा नाम मार्ग । कुणीही पत्करा मार्ग ।< br />
पत्करता नाम मार्ग । कधी न आडमार्ग ॥ ९१८ ॥< br />
< br />
येता जाता घेता नाम । भवतापास रामराम ।< br />
कोणतेही भजा नाम । आनंद मिळे ठाम ॥ ९१९ ॥< br />
< br />
नाम घ्या हो नाम । स्वार्थासाठी नाम ।< br />
चित्तशांती साठी नाम । आनंदासाठी नाम ॥ ९२० ॥< br />
< br />
येता जाता नाम भजता । स्वयेच जागृत होता ।< br />
प्रारब्ध भोग जाणता । तैशी पाऊले टाकता ॥ ९२१ ॥< br />
< br />
भगवंताच्या नामात । आनंद क्षणाक्षणात । < br />
नामाच्या सातत्यात । भगवंत सहवासात ॥ ९२२ ॥< br />
< br />
नाम कुणीही भजा । पण श्रद्धेने भजा ।< br />
येता जाता भजा । आनंद लुटत जा ॥ ९२३ ॥< br />
< br />
नामासाठी नाही काळवेळ । उपयुक्त सर्व वेळ ।< br />
प्रारब्धातले खेळ । नामानेच सुमेळ ॥ ९२४ ॥< br />
< br />
नाम घेता आनंदाने । जगाल तुम्ही खात्रीने ।< br />
सुखदुःखाच्या त्रासाने । न त्रस्त व्हाल त्याने ॥ ९२५ ॥< br />
< br />
नाम असावे मुखी । सुखदुःखे सारखी ।< br />
जो नामाची गोडी चाखी । तो अमृतच चाखी ॥ ९२६ ॥< br />
< br />
नामात प्रेरणा अनेक । आदेश एक एक ।< br />
ते पाळता एक एक । तोषता कित्येक ॥ ९२७ ॥< br />
< br />
सुख समृद्धी वैभव । काय घेता त्याची चव ! ।< br />
नामाची घेता चव । सर्वच वाटे बेचव ॥ ९२८ ॥< br />
< br />
सुख समृद्धी वैभवात । सुखदुःखे त्यात ।< br />
नामाच्या आनंदात । आनंदाच्या वैभवात ॥ ९२९ ॥< br />
< br />
धनाच्या समृद्धीने । कधी न तृप्ती न त्याने ।< br />
नामाच्या सातत्याने । सदा तृप्तच त्याने ॥ ९३० ॥< br />
< br />
नामात सर्व मिळते । नाम भजता कळते ।< br />
नामात जे जे मिळते । ते न कशात मिळते ॥ ९३१ ॥< br />
< br />
नामात मुख्य मिळते । गौण न टिकते ।< br />
शांती समाधान मिळते । वासना न उरते ॥ ९३२ ॥< br />
< br />
नेमके काय करावे ? । नामानेच सुचवावे ।< br />
तेणे नाम भजावे । आदेश पालन करावे ॥ ९३३ ॥< br />
< br />
प्रपंचातली सुखदुःखे । चित्ता जाळती सारखे ।< br />
नाम भजता मुखे । विरती सुखदुःखे ॥ ९३४ ॥< br />
< br />
देहाचे एकेक चोजले । नामानेच कळे ।< br />
पुरे जाहले चोजले । स्वये आपण बोले ॥ ९३५ ॥< br />
< br />
येता जाता नाम भजता । देहास विसरता ।< br />
नामास विसरता । देहास सजवता ॥ ९३६ ॥< br />
< br />
किती सजवणार देहास ? । अशाश्वतास ! ।< br />
नाम येऊद्या मुखास । तेणे शाश्वतास ॥ ९३७ ॥< br />
< br />
देहाच्या एकेक सुखास । जाळते चित्तास ।< br />
नका भजु देहास । सदा भजा नामास ॥ ९३८ ॥< br />
< br />
जातीभेद नामास । मान्य न कधी त्यास ।< br />
कुणीही भजावे नामास । जवळ करेल त्यास ॥ ९३९ ॥< br />
< br />
कुणीही नाम भजावे । जातीभेद विसरावे ।< br />
भगवंतास पहावे । चराचरी स्मरावे ॥ ९४० ॥< br />
< br />
कुणीही नाम भजता । आनंदच प्राप्त करता ।< br />
आनंद सर्वांकरता । नाही एकट्यापुरता ॥ ९४१ ॥< br />
< br />
संत तरले नामावर । नाही भेदभावावर ।< br />
नामाच्या भरंवशावर । सर्वच तरले आजवर ॥ ९४२ ॥< br />
< br />
नामावर भरंवसा ठेवा । भरंवशानेच जगता ।< br />
भरंवसाच ठरतो त्राता । कळले नाम घेता ॥ ९४३ ॥< br />
< br />
नाम जपावे मुखाने । केव्हांही हंसतमुखाने ।< br />
रहाल हंसत मुखाने । रहाल आनंदाने ॥ ९४४ ॥< br />
< br />
नाम येता मुखात । सुखदुःखे विरतात ।< br />
चिंता नष्ट होतात । सदा प्रसन्ने जगतात ॥ ९४५ ॥< br />
< br />
मुखी नाम येता । नाममयच होता ।< br />
नामात तल्लीन होता । देहभान विसरता ॥ ९४६ ॥< br />
< br />
आत्मा जोवरी देहात । तोवरी रहावे नामात ।< br />
नामाच्या सातत्यात । उद्विग्नता न मनात ॥ ९४७ ॥< br />
< br />
नाम घ्यावे येताजाता । जरी सवड न मिळता ।< br />
प्रारब्ध सहज भोगता । भयभीत न होता ॥ ९४८ ॥< br />
< br />
नाम घेता मुखाने । जगाल आत्मनिर्धाराने ।< br />
मनोबळ वाढल्याने । जगाल खात्रीने ॥ ९४९ ॥< br />
< br />
नाम असता मुखात । ठाम निश्चय मनात ।< br />
निश्चयाने जगण्यात । सुयश प्रयत्नात ॥ ९५० ॥< br />
< br />
नाम मुखी असता । धर्मरतच रहाता ।< br />
धर्माचरणे वागता । भगवत्‌कृपेने जगता ॥ ९५१ ॥< br />
< br />
मुखी असता नाम । धर्माचाच मुक्काम ।< br />
अधर्मास रामराम । सत्कृत्येच ठाम ॥ ९५२ ॥< br />
< br />
नाम मुखी येता । प्रारब्ध भोग जाणता ।< br />
विपरीत प्रसंग येता । सदाचरणे जगता ॥ ९५३ ॥< br />
< br />
नाम मुखी येता । चिंतनमय होता ।< br />
बरेवाईट कळता । सत्कर्मेच करता ॥ ९५४ ॥< br />
< br />
नामाचा लागता लळा । सत्वृत्तींचा लळा ।< br />
सत्वृत्ती आचरणाला । सुफळे नशीबाला ॥ ९५५ ॥< br />
< br />
नाम घ्यावे नाम । भगवंताचे नाम ।< br />
तळमळीने घ्यावे नाम । आंतरंगाच्या ओढीने नाम ॥ ९५६ ॥< br />
< br />
नामाच्या तळमळीला । नाम येते मुखाला ।< br />
तेणे एकेक प्रसंगाला । शिकाल तोंड द्यायला ॥ ९५७ ॥< br />
< br />
नामाच्या तळमळीत । नाम रसभरीत ।< br />
नाम रसाच्या तृप्तीत । आनंदाच्या तृप्तीत ॥ ९५८ ॥< br />
< br />
नाम घेता तळमळीने । हांक मारता खात्रीने ।< br />
बोलावता हक्काने । तो येतो प्रेमाने ॥ ९५९ ॥< br />
< br />
तळमळीच्या नामात । भगवंत पुढ्यात ।< br />
भगवंताशी बोलण्यात । आनंदी आनंद मनात ॥ ९६० ॥< br />
< br />
तळमळीला फार महत्व। नामातच कळते तत्व ।< br />
मनोमन पटता तत्व । नामालाच महत्व ॥ ९६१ ॥< br />
< br />
महत्व आहे तळमळीला । अंतरंगाच्या ओढीला ।< br />
येताजाता नाम मुखाला । वाढवता तळमळीला ॥ ९६२ ॥< br />
< br />
तळमळीत सर्व मिळते । हेही नामातच कळते ।< br />
तेणे नाम मुखी येते । येता जाता भजणे होते ॥ ९६३ ॥< br />
< br />
तळमळीने जे जे प्राप्त । नाही कशात ते प्राप्त ।< br />
नामाने तळमळ प्राप्त । नामातच सर्व प्राप्त ॥ ९६४ ॥< br />
< br />
नाम येता मुखाला । जाणता तळमळीला ।< br />
तेणे नामाच्या ओढीला । येताजाता मुखाला ॥ ९६५ ॥< br />
< br />
तळमळीवाचुन नामास । शुष्क रटाळ भकास ।< br />
तळमळीयुक्त नामास । आनंद प्रेरणा उल्हास ॥ ९६६ ॥< br />
< br />
नामाविण काही नाही । नामातच सर्व काही ।< br />
जे जे नामात नाही । ते ते कुठेही नाही ॥ ९६७ ॥< br />
< br />
नामात सर्व आहे । तेणे नाममय व्हावे ।< br />
नामात तल्लीन व्हावे । सर्व प्राप्त करावे ॥ ९६८ ॥< br />
< br />
नामात जे जे मिळते । नाम भजता कळते ।< br />
श्रद्धेने नाम भजण्याते । श्रद्धायुक्त जीवन होते ॥ ९६९ ॥< br />
< br />
नामात श्रद्धा ठेवा । संतांचा बोल आठवा ।< br />
संत अनुभव घ्यावा । जीव सत्कारणी लावा ॥ ९७० ॥< br />
< br />
नामाने प्रेरणा अनेक । श्रद्धेने भजता नाम एक ।< br />
नामावर तरले कित्येक । आपणही व्हावे एक ॥ ९७१ ॥< br />
< br />
नामातल्या प्रेरणा । प्रफुल्ल करे मना ।< br />
शांती समाधाने जगण्या । नाम उपयुक्त जाणा ॥ ९७२ ॥< br />
< br />
नामात शांती साठली । संतांनी अनुभवली ।< br />
प्रपंच माया लोपली । शांती उदया आली ॥ ९७३ ॥< br />
< br />
नामात शांती निश्चित । नामाजवळ स्थित ।< br />
शांती नामाची आश्रित । तेणे नामात व्हावे स्थित ॥ ९७४ ॥< br />
< br />
नामात शांती मिळते । नाम भजता कळते ।< br />
नाम ज्याच्या मुखी असते । शांती त्यास मिळते ॥ ९७५ ॥< br />
< br />
जीवनी शांतीस महत्व । तेणे नामास महत्व ।< br />
नामात खरे सत्व । नामातच शाश्वत तत्व ॥ ९७६ ॥< br />
< br />
नका भटकु शांतीसाठी । नामातच शांती प्राप्ती ।< br />
संत बोल सांठवा चित्ती । अनुभवा जीवनी शांती ॥ ९७७ ॥< br />
< br />
नाम ज्याच्या मुखात । तो शांती समाधानात ।< br />
नका भटकु अशाश्वतात । रहावे आत्म्याच्या आवाजात ॥ ९७८ ॥< br />
< br />
नाम भजा नाम । शांतीसाठी नाम ।< br />
निश्चय करा ठाम । सोडु नका नाम ॥ ९७९ ॥< br />
< br />
कुठच्याही प्रहरी नाम । कुठच्याही प्रसंगी नाम ।< br />
श्रद्धेने भजता नाम । प्रपंचात दिसे राम ॥ ९८० ॥< br />
< br />
नामाचा निश्चय पक्का । जीवनात हुकुमी एक्का ।< br />
तरण्या जीवन नौका । नामच माझा सखा ॥ ९८१ ॥< br />
< br />
श्रद्धा ठेवा नामावर । नको दुसरी कशावर ।< br />
अवलंबता नामावर । रहाल शाश्वतावर ॥ ९८२ ॥< br />
< br />
श्रद्धा ठेवता नामात । जगाल शाश्वतात ।< br />
अशाश्वत त्यजण्यात । मनःशांती लाभे त्यात ॥ ९८३ ॥< br />
< br />
धनाने हुरळु नका । नामाचे बोल ऐका ।< br />
धनलोभ एकसारखा । तेणेच जीवनी धोका ॥ ९८४ ॥< br />
< br />
नामाचा निश्चय करावा । नामात वेळ घालवा ।< br />
आज नामाला आळवा । आज काळाला घालवा ॥ ९८५ ॥< br />
< br />
नामाचा निश्चय करा । नामच बनेल आसरा ।< br />
नको जीव कावरा बावरा । नामात तुम्ही सावरा ॥ ९८६ ॥< br />
< br />
नामाच्या निश्चयात । निश्चयाचे बोल चित्तात ।< br />
निश्चयाने वागण्यात । रहाता आत्मविश्वासात ॥ ९८७ ॥< br />
< br />
नाम पाप विनाशक । कुठेही भजा नाम एक ।< br />
अनुभव घ्या एकेक । संतांचे बोल अकेक ॥ ९८८ ॥< br />
< br />
नका पडु सिद्धी मागे । रहावे नामात जागे ।< br />
नामानेच होता जागे । कधी न पडाल सिद्धीमागे ॥ ९८९ ॥< br />
< br />
नाम तुम्हा सदा तारक । सिद्धी कधी कधी बाधक ।< br />
नामच तुम्हा पोषक । सिद्धी अहंकारास ॥ ९९० ॥< br />
< br />
नाम घ्यावे भल्यासाठी । न भलते होण्यासाठी ।< br />
भलतेच टाळण्यासाठी । सदा भजावे त्यासाठी ॥ ९९१ ॥< br />
< br />
ज्याच्या मुखी नाम येते । त्याला कळते भलते ।< br />
सावधच रहाण्याते । सर्व काही मिळते ॥ ९९२ ॥< br />
< br />
नाम असते ज्याच्या मुखी । तो सदा हंसतमुखी ।< br />
आनंदाच्या अगणिक राशी । सहज येती त्याचे पाशी ॥ ९९३ ॥< br />
< br />
नाम मुखी असण्यात । भाग्यच समजा त्यात ।< br />
सहज सोपे मिळवतात । नामाशी तुम्ही राहाण्यात ॥ ९९४ ॥< br />
< br />
नको चिंतन प्रारब्धाचे । आपण व्हावे नामाचे ।< br />
भोग जे जे नशीबाचे । सुसह्ये भोगायचे ॥ ९९५ ॥< br />
< br />
प्रारब्धाच्या चिंतनात । नाना यातना त्यात ।< br />
परी नामाच्या चिंतनात । आनंदच मिळे त्यात ॥ ९९६ ॥< br />
< br />
नाम भजा इतुके । नको परके पोरके ।< br />
नको लाड देहाचे । लाड करा नामाचे ॥ ९९७ ॥< br />
< br />
नाम इतुके भजावे । वेळेचेही भान नसावे ।< br />
काळानेही सावध व्हावे । इतुके नाम भजावे ॥ ९९८ ॥< br />
< br />
भजा भजा नाम इतुके । काही न चाले काळाचे ।< br />
भय न आपणा त्याचे । भयमुक्त जगण्याचे ॥ ९९९ ॥< br />
< br />
नामात आनंद इतुका । पेढा खाण्या इतुका ।< br />
गोडी चाखण्याचा । अट्टाहास करायचा ॥ १००० ॥< br />
< br />
नामात आहे आनंद । भजता मिळे आनंद ।< br />
प्राप्त करता आनंद । व्हाल आनंदीआनंद ॥ १००१ ॥< br />
< br />
आनंद अवर्णनीय । आपण घ्यावा अनुभव ।< br />
होता तुम्ही नाममय । व्हाल आनंदमय ॥ १००२ ॥< br />
< br />
नामात कळतो स्वार्थ । कळे जीवनाचा अर्थ ।< br />
नामच चालवे चरीतार्थ । साधता परमार्थ ॥ १००३ ॥< br />
< br />
नामात स्वार्थ परमार्थ । जीवनाचा खरा अर्थ ।< br />
नामच खरे उपयुक्त । हेच म्हणणे सार्थ ॥ १००४ ॥< br />
< br />
नामात रमता अर्थ । अन्यथा जीवन व्यर्थ ।< br />
नामच खरे समर्थ । भजता व्हाल समर्थ ॥ १००५ ॥< br />
< br />
नामाचे मंदीर बनवा । तेणे प्रसन्न व्हा ।< br />
शांती समाधान पहा । आनंदी आनंदी व्हा ॥ १००६ ॥< br />
< br />
नामाच्या मंदीरात । आत्मानंद वसे त्यात ।< br />
त्याची पूजा करण्यात । प्रसन्नता चित्तात ॥ १००७ ॥< br />
< br />
नामाचे मंदीर ऐसे । थक्कच व्हावे ऐसे ।< br />
मंदीरातुन हलावेसे । कधीच वाटत नसे ॥ १००८ ॥< br />


</p>
          </section>
        </div>
      </Layout>
    )
  }
}

export default Generic
